// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:58:15.859Z
// Property: The Dorset (ID: 6767906449167618)
// Collections: 31 amenities, 10 floorplans (live), 50 photos, 72 POIs, 3 reviews, 9 virtual tours, 4 office hours, 24 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167618",
  "property_external_id": "1701784",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/the-dorset-kansas-city-mo/x0p737n/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Dorset/@39.0444043,-94.5956386,889m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0efde3bd52bf7:0xa80b0969a9cc8792!8m2!3d39.0444043!4d-94.5956386!16s%2Fg%2F11h45dkvjl?entry=ttu&g_ep=EgoyMDI2MDkxNi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1701784 p1669887",
  "property_status": null,
  "property_slug": "the-dorset",
  "property_name": "The Dorset",
  "property_website_url": "https://www.thedorsetapartments.com/",
  "property_domain": "https://www.thedorsetapartments.com/",
  "property_address": "760 W 46th St",
  "property_full_address": "760 W 46th St, Kansas City, MO 64112",
  "property_address_1": "760 W 46th St",
  "property_address_2": null,
  "property_address_city": "Kansas City",
  "property_address_state": "MO",
  "property_address_zip_full": null,
  "property_address_zip": "64112",
  "property_address_country": "US",
  "property_address_county": "Jackson County",
  "property_neighborhood_address": "Midtown - Westport",
  "property_address_latitude": "39.04442299999999",
  "property_address_longitude": "-94.5956262",
  "property_email": "rentcafe.46p@pricekc.com",
  "property_phone": "(816) 205-7182",
  "property_call_tracking_phone": "816-205-7182",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p>The Dorset Apartment Homes offers luxury one-, two-, and three-bedroom apartments in Kansas City’s Plaza Westport neighborhood. Our homes feature crown molding, high ceilings, natural light, fully equipped kitchens, and spacious closets. Select apartments add a private balcony or patio, a gas fireplace, or upgraded cabinetry.</p><p>Residents enjoy a 24-hour fitness center, reserved underground parking, elevators in every building, and an on-site management and maintenance team. Explore our floor plans and find your next apartment near the Plaza.</p>",
  "property_long_description": "<p><strong>Live where Plaza polish meets Westport energy.</strong> At The Dorset, you’re tucked into one of Kansas City’s most connected Midtown locations, moments from Country Club Plaza shopping and dining, Westport’s restaurants and nightlife, Saint Luke’s Hospital, the Nelson-Atkins Museum of Art, Kemper Museum, and the expanded KC Streetcar line.</p><p>Inside, choose from spacious one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> with the everyday upgrades that make home feel effortless: stainless steel appliances, hardwood floors, high ceilings, full-size washer/dryer, oversized walk-in closets, and select layouts with a study, built-in desk, or oversized patio/balcony. Around the community, your routine gets even easier with elevator access, package service, on-site maintenance, a fitness center, bike racks, a guest suite, gated access, and a rooftop deck made for taking in the neighborhood.</p><p>From quiet mornings at home to nights out along the Plaza and Westport, The Dorset gives you a polished Kansas City address with room to settle in and plenty to explore nearby.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a1a2c3-6a15-738d-b5a0-f95b728f4427.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor seating area with chairs and a table on a balcony overlooking buildings and a park.",
    "public_id": "01a1a2c3-6a15-738d-b5a0-f95b728f4427",
    "storage_key": "property/6767906449167618/01a1a2c3-6a15-738d-b5a0-f95b728f4427.webp",
    "width": 1920,
    "height": 1281
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "67",
  "property_year_built": "2020",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "85.07462686567165",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-375",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://thedorsetapartments.securecafeapplicant.com/onlineleasing/content3/access/the-dorset1/floorplans",
  "property_resident_portal_url": "https://thedorsetapartments.securecafenet.com/residentservices/the-dorset1/userlogin",
  "property_apply_now_url": "https://thedorsetapartments.securecafeapplicant.com/onlineleasing/content3/access/the-dorset1/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98b-e811-76ef-abee-a90b216cfdbe.webp",
  "property_primary_logo_media": {
    "alt_text": "The Dorset logo with a shield and laurel leaves, also includes 'The Dorset A Price Brothers Community'",
    "public_id": "019fc98b-e811-76ef-abee-a90b216cfdbe",
    "storage_key": "property/6767906449167618/019fc98b-e811-76ef-abee-a90b216cfdbe.webp",
    "width": 1238,
    "height": 1125
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a13fe6-c0f0-702d-a052-97fd036a84af.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Property logo featuring a blue shield with a white 'D' and laurel leaves.",
    "public_id": "01a13fe6-c0f0-702d-a052-97fd036a84af",
    "storage_key": "property/6767906449167618/01a13fe6-c0f0-702d-a052-97fd036a84af.webp",
    "width": 1238,
    "height": 1125
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98b-e811-76ef-abee-a90b216cfdbe.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Dorset logo with a shield and laurel leaves, also includes 'The Dorset A Price Brothers Community'",
    "public_id": "019fc98b-e811-76ef-abee-a90b216cfdbe",
    "storage_key": "property/6767906449167618/019fc98b-e811-76ef-abee-a90b216cfdbe.webp",
    "width": 1238,
    "height": 1125
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#1B365D",
  "property_secondary_color": "#2C5697",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#F3CFB3",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1.5 - 2.5",
  "property_bathrooms_min": "1.5",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "1033 - 1652",
  "property_sqft_min": "1033",
  "property_sqft_max": "1652",
  "property_price_range": "1945 - 3140",
  "property_price_min": "1945",
  "property_price_max": "3140",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/TheDorsetApartments",
  "property_instagram_url": "https://www.instagram.com/thedorsetapartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ9yvVO97vwIcRkofMqWkJC6g",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Dorset",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection at Our Community",
  "property_home_amenities_blurb": "<p><strong>Everyday ease, elevated.</strong> The Dorset pairs practical comforts with polished style, from a rooftop deck and fitness center to package service, elevator access, bike racks, and a pet washing station. Inside, stainless steel appliances, hardwood floors, high ceilings, full-size washer/dryer, oversized walk-in closets, and air conditioning keep each space feeling streamlined. Select layouts add a built-in desk, study, or oversized patio/balcony for even more flexibility.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room to define your day.</strong> Choose from one-, two-, and three-bedroom layouts at The Dorset, with open living areas, high ceilings, hardwood floors, stainless steel appliances, full-size washer/dryer, and oversized walk-in closets. Select homes add a built-in desk, study, or oversized patio/balcony—bringing extra flexibility to Midtown-Westport living.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life at The Dorset.</strong> Preview sunlit kitchens with broad islands, stainless steel finishes, high ceilings, and warm wood-style floors, then look closer at sleek baths, walk-in closets, and balconies above Midtown-Westport. The full gallery also captures the rooftop deck with lounge seating and skyline views, plus polished amenity spaces designed for everyday ease.</p>",
  "property_home_neighborhood_blurb": "<p>The Dorset sits at 760 W. 46th Street in Kansas City’s Plaza Westport neighborhood, surrounded by some of the city’s favorite restaurants, coffee shops, boutiques, and galleries.</p><p><br></p><p>The Country Club Plaza is just steps away, with upscale shopping, outdoor dining, and seasonal events like the famous holiday lights. Head the other direction into Westport for live music, craft cocktails, and a thriving local food scene.</p><p><br></p><p>The free KC Streetcar is less than a mile away and connects you to Crown Center, the Crossroads, Downtown, and the River Market. For the commute, I-35, I-435, and US-71 are all close by.</p><p><br></p><p>Explore the neighborhood map and discover what is just outside your door.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents love The Dorset’s easygoing Midtown-Westport lifestyle.</strong> Reviews call out spacious apartments, a calm and well-kept setting, and service that’s quick, clear, and helpful from move-in on. The smaller, quieter feel stands out, along with walkable access to restaurants, shops, groceries, and the library.</p>",
  "property_neighborhood_blurb": "<p><strong>Make Midtown your map.</strong> From The Dorset, your day can move from coffee on Main Street to dinner along Westport Road, a show at the Uptown Theater, or an easy errand run through Country Club Plaza’s open-air shops. This part of Kansas City feels layered in the best way—historic Westport storefronts, independent restaurants like Tailleur and Westport Café, creative venues, pocket parks, and the artful edges of Southmoreland all close together. When you want a greener pause, Mill Creek Park and Loose Park are within easy reach; when you want to range farther, nearby RideKC and KC Streetcar connections open up Downtown, River Market, Crossroads, and UMKC. After exploring, come home to the rooftop deck and the <a href=\"/amenities\">everyday conveniences</a> that keep the location easy to enjoy.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Watch the sunset over the Country Club Plaza from our rooftop deck, get a workout in at the fitness center, or book the guest suite when friends come to town. The Dorset also has a parking garage, controlled-access entry, elevators, package receiving, a pet washing station, bike racks, and on-site emergency maintenance.</p><p>Inside, every apartment has 9-foot ceilings, crown molding, a fully equipped kitchen, and washer and dryer connections. Select homes add a gas fireplace, a private balcony or patio, or a den or study.</p><p><br></p><p>Flexible leases and corporate housing make The Dorset a great fit for professionals, including staff at nearby Saint Luke’s Hospital. </p><p><br></p><p>Explore the full list of amenities above.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make The Dorset home?</strong> Choose a spacious one-, two-, or three-bedroom <a href=\"/floor-plans\">floor plan</a> with polished finishes, everyday conveniences, and a connected Midtown setting near Plaza and Westport energy. Start your online application today and take the next step toward a Kansas City address with room to settle in.</p>",
  "property_contactus_blurb": "<p><strong>Questions? We’re here to help.</strong> Contact The Dorset leasing team for details about spacious one-, two-, and three-bedroom homes, everyday finishes, community conveniences, or directions to our connected Midtown Kansas City location near the Plaza and Westport.</p>",
  "property_faqs_blurb": "<p><strong>Questions about life at The Dorset?</strong> Start here for quick answers about the community, leasing, <a href=\"/floor-plans\">floor plans</a>, features, and day-to-day details. If you don’t see what you need, the leasing team is happy to help—just <a href=\"/contact-us\">reach out</a>.</p>",
  "property_floorplans_blurb": "<p>Find the floor plan that fits your life at The Dorset. Choose from efficient one-bedroom apartments with smart storage, two-bedroom layouts with room to spread out, or spacious three-bedroom homes. Floor plans range from about 659 to 1,272 square feet.</p><p><br></p><p>Every layout includes 9-foot ceilings, crown molding, and a fully equipped kitchen with a dishwasher, microwave, self-cleaning oven, and refrigerator with ice maker. Select floor plans add a den or study, a private balcony or patio, a gas fireplace, or upgraded appliances and cabinetry.</p><p><br></p><p>Browse the floor plans below to compare layouts, square footage, and current availability. Ready to see The Dorset in person? Schedule a tour online or call today.</p>",
  "property_gallery_blurb": "<p>Browse photos of The Dorset Apartment Homes in Kansas City, from crown molding and natural light to rooftop views of the Country Club Plaza. Our gallery includes apartment interiors, community spaces, and the details that give The Dorset its classic character.</p><p><br></p><p>Look through living spaces with high ceilings, fully equipped kitchens, and private balconies and patios in select homes, along with the rooftop deck, fitness center, and underground parking garage.</p><p><br></p><p>Like what you see? Schedule a tour and step inside The Dorset.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore The Dorset on the map.</strong> See available apartments and get a feel for a connected Midtown address between Plaza polish and Westport energy, with dining, shopping, culture, transit, and everyday essentials close by.</p>",
  "property_pets_blurb": "<p><strong>Pets feel considered here, too.</strong> At The Dorset, your cat or dog has a home base with everyday convenience built in—from a dedicated <a href=\"/amenities\">pet washing station</a> for post-walk cleanups to elevator access that keeps quick trips simple. Step out in Midtown-Westport for fresh air along nearby sidewalks and Mill Creek Park Trail, then return to a smoke-free community with on-site maintenance and package service helping the day run smoothly.</p><p>Your pet fee also includes access to Price Brothers’ Pet Royalty Club, offering perks at local pet-related businesses. Have questions about your pet’s fit? <a href=\"/contact-us\">Contact the leasing team</a> before you apply.</p>",
  "property_referafriend_blurb": "<p><strong>Love life at The Dorset?</strong> Share the Plaza polish, Westport energy, spacious floor plans, and rooftop-deck views with someone who should see it for themselves. Send a referral today and invite a friend to make their next Kansas City address right here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at The Dorset.</strong><br>Keep everyday living effortless from your resident portal: pay rent, submit maintenance requests, and manage your account in one convenient place. It’s a simple way to stay connected to home at your polished Kansas City address.</p>",
  "property_reviews_blurb": "<p><strong>What residents are saying about The Dorset:</strong> reviews highlight a calm, well-kept building with spacious apartments, responsive service, and a location that makes daily errands and nights out feel easy.</p><p>Residents consistently praise the management and maintenance teams by name, noting quick help, clear communication, and a move-in process described as “seamless.” You’ll also see appreciation for The Dorset’s smaller, quieter feel, friendly atmosphere, and walkable access to restaurants, shops, the library, and grocery options in Midtown-Westport.</p>",
  "property_created_at": "1785792750677",
  "property_scheduletour_blurb": "<p>See The Dorset Apartment Homes for yourself. Schedule a tour to explore available apartment homes and community spaces in Plaza Westport, Kansas City.</p><p>During your visit, take a closer look at apartment interiors, floor plan options, and community amenities, including our indoor and outdoor pools, fitness center, and underground parking, while getting your questions answered by our leasing team.</p><p><br></p><p>Choose an available tour option and time below to plan your visit to The Dorset Apartment Homes.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong> The Dorset leasing team will be in touch soon to help with your next steps. In the meantime, picture a polished Midtown address with spacious floor plans, effortless in-home finishes, and a rooftop deck that keeps the neighborhood close.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. The Dorset",
  "property_seo_title_home": "The Dorset | Luxury Apartments in Kansas City, MO",
  "property_seo_description_home": "Luxury 1, 2 & 3 bedroom apartments in Plaza Westport, Kansas City, MO. Rooftop deck, fitness center, parking garage & hardwood floors. Near Country Club Plaza.",
  "property_seo_title_floorplans": "1, 2 & 3 Bedroom Floor Plans | The Dorset Kansas City",
  "property_seo_description_floorplans": "Browse 1, 2 & 3 bedroom floor plans at The Dorset in Kansas City, MO. High ceilings, hardwood floors, stainless appliances & oversized walk-in closets.",
  "property_seo_title_amenities": "Rooftop Deck, Fitness Center & Parking | Kansas City",
  "property_seo_description_amenities": "The Dorset offers a rooftop deck, fitness center, parking garage, pet washing station, bike racks & controlled access in Plaza Westport, Kansas City, MO.",
  "property_seo_title_gallery": "Apartment Photos | The Dorset Kansas City, MO 64112",
  "property_seo_description_gallery": "Browse photos of The Dorset in Plaza Westport, Kansas City, MO — rooftop deck, modern interiors, hardwood floors & community spaces. Picture yourself here!",
  "property_seo_title_virtualtours": "Virtual Tours | The Dorset Apartments",
  "property_seo_description_virtualtours": "Step inside The Dorset in Kansas City, MO! Enjoy vibrant living with spacious one, two, and three-bedroom apartments. Take a virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | The Dorset Apartments",
  "property_seo_description_interactivemap": "Find your perfect sanctuary at The Dorset in Kansas City, MO. Enjoy spacious floor plans, modern amenities, and an interactive map to guide your home search!",
  "property_seo_title_neighborhood": "Plaza Westport Kansas City Neighborhood Guide | MO",
  "property_seo_description_neighborhood": "The Dorset is steps from Country Club Plaza, boutiques, galleries, restaurants & metro stations in Plaza Westport, Kansas City, MO. Explore the neighborhood.",
  "property_seo_title_contact": "Contact The Dorset Apartments | Kansas City, MO",
  "property_seo_description_contact": "Have questions about our apartments in Kansas City, MO? Reach The Dorset leasing team by phone or online at 760 W 46th St. We'd love to help you find your home!",
  "property_seo_title_faqs": "FAQs | Apartments in Kansas City, MO",
  "property_seo_description_faqs": "Find answers to your questions about The Dorset in Kansas City, MO. Learn about our spacious floor plans, top-notch amenities, and pet-friendly community!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Kansas City, MO",
  "property_seo_description_reviews": "Experience vibrant living at The Dorset in Kansas City! Check out resident reviews to see why our community is top-notch for comfort, convenience, and style!",
  "property_seo_title_applynow": "Apply Now | Apartments in Kansas City, MO",
  "property_seo_description_applynow": "Find your perfect fit at The Dorset in Kansas City! Choose from spacious one to three-bedroom floor plans and enjoy top-notch amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | The Dorset",
  "property_seo_description_residentaccess": "Unlock convenience at The Dorset! Log in to your resident portal for easy rent payments, maintenance requests, and exclusive community updates in Kansas City.",
  "property_seo_title_referafriend": "Refer A Friend | The Dorset",
  "property_seo_description_referafriend": "Invite friends to share in the vibrant lifestyle at The Dorset in Kansas City, MO. Great friends make great neighbors—refer a friend today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Dorset Kansas City, MO 64112",
  "property_seo_description_scheduletour": "Ready to see The Dorset in person? Schedule an in-person or virtual tour of our 1, 2 & 3 bedroom apartments in Plaza Westport, Kansas City, MO today!",
  "property_seo_title_privacy": "Privacy Policy | The Dorset",
  "property_seo_description_privacy": "At The Dorset in Kansas City, we value your privacy. Learn how we protect your information and ensure a safe community experience. View our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | The Dorset",
  "property_seo_description_accessibility": "At The Dorset in Kansas City, MO, we prioritize digital inclusion. Discover how our accessibility features enhance your living experience today!",
  "property_seo_title_sitemap": "Sitemap | The Dorset",
  "property_seo_description_sitemap": "Uncover the hidden gems of The Dorset in Kansas City, MO. Navigate your way through our sitemap for an effortless apartment hunting experience!",
  "property_seo_title_thankyou": "Thank You | The Dorset",
  "property_seo_description_thankyou": "Thank you for reaching out to The Dorset in Kansas City, MO! Our team will connect soon to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet-Friendly Apartments | The Dorset Kansas City MO",
  "property_seo_description_pets": "The Dorset welcomes cats & dogs in Plaza Westport, Kansas City, MO. Up to 2 pets per home. Enjoy our pet washing station & Price Brothers Pet Royalty Club.",
  "property_updated_at": "1793732085430",
  "amenities": [
    {
      "id": "ec_6b06ff741933d498cd90223f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941246",
      "title": "Parking Garage",
      "amount": "false",
      "description": "& Assigned Parking",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66e-e487-74bb-aa70-65334a587d5e.webp",
      "amenity_image_media": {
        "alt_text": "Exterior of a multifamily building with a large roll-up garage door.",
        "public_id": "01a0b66e-e487-74bb-aa70-65334a587d5e",
        "storage_key": "property/6767906449167618/01a0b66e-e487-74bb-aa70-65334a587d5e.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Attached Garages at The Dorset, Kansas City, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bfe882d3b677e70d3a13b21c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941244",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66e-e9c6-7630-a439-d4bfa9ae82a6.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, weight bench, and free weights.",
        "public_id": "01a0b66e-e9c6-7630-a439-d4bfa9ae82a6",
        "storage_key": "property/6767906449167618/01a0b66e-e9c6-7630-a439-d4bfa9ae82a6.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "Fitness center at The Dorset with cardio machines, free weights, and workout bench",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_64b26e2d10f5b0c9ac77ba8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941288",
      "title": "High-Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b2be8f46c88f7dc8f4a9d0da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941261",
      "title": "Bike Racks",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66e-e9ab-729c-9780-106e0b153c92.webp",
      "amenity_image_media": {
        "alt_text": "Spiral bike racks inside a concrete parking garage with arched windows.",
        "public_id": "01a0b66e-e9ab-729c-9780-106e0b153c92",
        "storage_key": "property/6767906449167618/01a0b66e-e9ab-729c-9780-106e0b153c92.webp",
        "width": 1920,
        "height": 1282
      },
      "amenity_image_alt_text": "Bike racks at The Dorset located in covered parking area for convenient bicycle storage",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc3e9cf7adad236e1b69cbca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941242",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66e-d3bf-7708-91d3-1f757ab20349.webp",
      "amenity_image_media": {
        "alt_text": "Hallway with elevator doors, a cabinet with decor, and two doors.",
        "public_id": "01a0b66e-d3bf-7708-91d3-1f757ab20349",
        "storage_key": "property/6767906449167618/01a0b66e-d3bf-7708-91d3-1f757ab20349.webp",
        "width": 1920,
        "height": 1283
      },
      "amenity_image_alt_text": "Interior hallway at The Dorset with elevator access and nearby apartment doors",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c99ea65db8d3a7160805f50a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941240",
      "title": "Controlled Access / Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e35bde961121b965afe7757",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941271",
      "title": "On-Site & Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_45c9490ad5e384188bc95ac0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941269",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66e-d135-75d9-ab43-2dc802a2f155.webp",
      "amenity_image_media": {
        "alt_text": "Interior mailboxes with artwork above.",
        "public_id": "01a0b66e-d135-75d9-ab43-2dc802a2f155",
        "storage_key": "property/6767906449167618/01a0b66e-d135-75d9-ab43-2dc802a2f155.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "A wall with a row of mailboxes and pictures above it.,A white cabinet with a black handle is in a room with a black mat on the floor.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b1af404810c27c5f289e248",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941248",
      "title": "Flexible Lease Options",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8c4a3e6e8f784f082a2cf5da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941250",
      "title": "Pet Washing Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66e-e0b9-7144-9568-99f13474c4c3.webp",
      "amenity_image_media": {
        "alt_text": "Pet grooming station with a stainless steel tub and adjustable grooming table.",
        "public_id": "01a0b66e-e0b9-7144-9568-99f13474c4c3",
        "storage_key": "property/6767906449167618/01a0b66e-e0b9-7144-9568-99f13474c4c3.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "Pet Spa Center at The Dorset, Kansas City, MO,Pet Spa at The Dorset, Kansas City, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0ed24f5586d6ab7003e3ee8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941289",
      "title": "Rooftop Deck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66e-f2e8-70eb-a508-80b9376f656e.webp",
      "amenity_image_media": {
        "alt_text": "Lounge chairs on a rooftop deck with trees and city skyline in the background.",
        "public_id": "01a0b66e-f2e8-70eb-a508-80b9376f656e",
        "storage_key": "property/6767906449167618/01a0b66e-f2e8-70eb-a508-80b9376f656e.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "Rooftop patio at The Dorset with lounge chairs overlooking trees and surrounding neighborhood views,Large Living Room at The Dorset, Kansas City, 64112,A balcony with a table and chairs overlooks a cityscape. at The Dorset, Kansas City, 64112,Rooftop Patio at The Dorset, Kansas City, 64112,Rooftop Deck View at The Dorset, Kansas City, MO",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a4704f459031adc1e61838e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "121061392",
      "title": "Guest Suite",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66e-f2e6-751c-ad22-c1ed7b1bb275.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, TV, and an armchair.",
        "public_id": "01a0b66e-f2e6-751c-ad22-c1ed7b1bb275",
        "storage_key": "property/6767906449167618/01a0b66e-f2e6-751c-ad22-c1ed7b1bb275.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "Guest suite bedroom at The Dorset with dresser, TV, seating chair, and view toward kitchenette area,A bathroom with a toilet, sink, and a glass shower stall.,Guest suite kitchenette at The Dorset with granite countertops, wood cabinetry, sink, and appliance space,Guest suite bedroom at The Dorset featuring a queen bed, nightstand, window with natural light, and wood-style flooring,A bathroom with a sink, mirror, and towel rack.,Guest suite bedroom at The Dorset with dresser, TV, seating chair, and view toward kitchenette area,Guest suite bedroom at The Dorset featuring a queen bed, nightstand, window with natural light, and wood-style flooring",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_81b5d1441bbd382542ebdfb1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941249",
      "title": "Smoke-Free Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66e-ffe3-7110-b529-cad21bf6cec0.webp",
      "amenity_image_media": {
        "alt_text": "The Dorset monument sign with stone facade and manicured bushes.",
        "public_id": "01a0b66e-ffe3-7110-b529-cad21bf6cec0",
        "storage_key": "property/6767906449167618/01a0b66e-ffe3-7110-b529-cad21bf6cec0.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Property Signage at The Dorset, Kansas City, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2fcff4ed32b96630824647ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "121061432",
      "title": "Easy Access to Shopping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-0c69-768b-b7b9-a018917121c2.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of a city park with surrounding apartment buildings and businesses.",
        "public_id": "01a0b66f-0c69-768b-b7b9-a018917121c2",
        "storage_key": "property/6767906449167618/01a0b66f-0c69-768b-b7b9-a018917121c2.webp",
        "width": 1920,
        "height": 1440
      },
      "amenity_image_alt_text": "A cityscape with a mix of modern and older buildings, a large green park area, and a busy road intersection.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9211a39a46db70362b4d77e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "127804893",
      "title": "Near St. Luke's Hospital",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-0a37-7379-a163-ecbf8ea12135.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of Saint Luke's Hospital campus with surrounding cityscape",
        "public_id": "01a0b66f-0a37-7379-a163-ecbf8ea12135",
        "storage_key": "property/6767906449167618/01a0b66f-0a37-7379-a163-ecbf8ea12135.webp",
        "width": 1920,
        "height": 1440
      },
      "amenity_image_alt_text": "Aerial view of St. Luke’s Hospital located near The Dorset community in Kansas City",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b86cc2d013d6ce5d4a6dcbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "122755412",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee5d4f3a4441b6f826a5759e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941290",
      "title": "Corporate Housing Options",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f8e4df9cfafd24fba4c79d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941285",
      "title": "Full-Size Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-2030-7369-9501-bd7bd9fda724.webp",
      "amenity_image_media": {
        "alt_text": "In-unit washer and dryer with storage shelves.",
        "public_id": "01a0b66f-2030-7369-9501-bd7bd9fda724",
        "storage_key": "property/6767906449167618/01a0b66f-2030-7369-9501-bd7bd9fda724.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Washer Dryer In Unit at The Dorset, Kansas City, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e3c76e9f3a1ad4c012f47060",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941282",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "Including Side-by-Side Refrigerator, Dishwasher & Built-in Microwave",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-2365-741d-95a0-94382f27d460.webp",
      "amenity_image_media": {
        "alt_text": "Stainless steel refrigerator, wood cabinets, granite countertops, and a stove in a modern kitchen.",
        "public_id": "01a0b66f-2365-741d-95a0-94382f27d460",
        "storage_key": "property/6767906449167618/01a0b66f-2365-741d-95a0-94382f27d460.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "a kitchen with wooden cabinets and stainless steel appliances at The Dorset, Kansas City, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ddd100090d07d8cd23a4fac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941274",
      "title": "Sink Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_321fc9b94c754d9891d8e06d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941281",
      "title": "Oversized Patio/Balcony*",
      "amount": "false",
      "description": "*with Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-2e44-76dd-9084-217e83e5ed7f.webp",
      "amenity_image_media": {
        "alt_text": "Balcony with outdoor seating area, featuring a sofa and a dining set.",
        "public_id": "01a0b66f-2e44-76dd-9084-217e83e5ed7f",
        "storage_key": "property/6767906449167618/01a0b66f-2e44-76dd-9084-217e83e5ed7f.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Large Balcony at The Dorset, Kansas City, Missouri,Private Balcony And Patio at The Dorset, Kansas City, MO,A large, private fenced-in balcony with two windows and beautiful French doors. at The Dorset, Kansas City, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e4514eb3f709745ef9c39524",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941279",
      "title": "Oversized Walk-in Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-423d-72fa-9672-7bdd658c0447.webp",
      "amenity_image_media": {
        "alt_text": "Walk-in closet with two levels of shelving and hanging rods, stocked with clothes and folded items.",
        "public_id": "01a0b66f-423d-72fa-9672-7bdd658c0447",
        "storage_key": "property/6767906449167618/01a0b66f-423d-72fa-9672-7bdd658c0447.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "A large walk-in bedroom closet with built-in wire racks. at The Dorset, Kansas City, 64112,Closet View at The Dorset, Kansas City, 64112,A large walk-in bedroom closet with built-in wire racks.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba520f10ac3c2644f07d7e34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941276",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5d974694df27e2bc53fc04d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941277",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-42ff-71e6-97bc-c00bafee698f.webp",
      "amenity_image_media": {
        "alt_text": "Open-concept living area and kitchen with island, white sofa, and dining table.",
        "public_id": "01a0b66f-42ff-71e6-97bc-c00bafee698f",
        "storage_key": "property/6767906449167618/01a0b66f-42ff-71e6-97bc-c00bafee698f.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "a kitchen with a center island next to a living room with a couch and a table at The Dorset, Kansas City, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_939e5e25e168b2bb98651600",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941278",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-39a4-76e0-8173-7f09bb57517d.webp",
      "amenity_image_media": {
        "alt_text": "Spacious open-concept living area with a kitchen, dining area, and living room.",
        "public_id": "01a0b66f-39a4-76e0-8173-7f09bb57517d",
        "storage_key": "property/6767906449167618/01a0b66f-39a4-76e0-8173-7f09bb57517d.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Living Room With Kitchen Area at The Dorset, Kansas City, MO",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_628d72ae8e27a4f435b3d09d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941228",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "with Electronic Thermostat",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_66c73fb1ad26b194a55ff9a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941258",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-402e-730f-82b3-5efe6852152c.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with TV and dresser, view into living area and bathroom",
        "public_id": "01a0b66f-402e-730f-82b3-5efe6852152c",
        "storage_key": "property/6767906449167618/01a0b66f-402e-730f-82b3-5efe6852152c.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Bedroom With Ceiling Fan at The Dorset, Kansas City, 64112,Living Room With Kitchen View at The Dorset, Kansas City, 64112",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bd149915ed9c2abc9d86a698",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941229",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7d225e7c741958bd765d0dfa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "120941286",
      "title": "Wheelchair Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69cdd6d638ac4acb6d4b6638",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "123210267",
      "title": "Study*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6abc2d13c27e73fec578b574",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "external_id": "123210266",
      "title": "Built-in Desk*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-4f6f-763f-908e-c3c9f7cf5cf8.webp",
      "amenity_image_media": {
        "alt_text": "Hallway with a built-in desk and a chair, featuring a laptop and decorative shelving.",
        "public_id": "01a0b66f-4f6f-763f-908e-c3c9f7cf5cf8",
        "storage_key": "property/6767906449167618/01a0b66f-4f6f-763f-908e-c3c9f7cf5cf8.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Work Desk at The Dorset, Kansas City, MO",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_ab09836124b72f61e64c58f0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66e-bb60-709a-b155-28308642268e.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with island and view into bedroom.",
        "public_id": "01a0b66e-bb60-709a-b155-28308642268e",
        "storage_key": "property/6767906449167618/01a0b66e-bb60-709a-b155-28308642268e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into this spacious open-concept living area, featuring a fully equipped kitchen with a large island, a comfortable dining space, and a glimpse into the private bedroom.",
      "link": "false",
      "alt_text": "Modern kitchen and dining area with island and view into bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/17-760 W 46th St-16_final.jpg"
    },
    {
      "id": "ec_f9f1a93290a363095cc19ac5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-66c9-7414-ba30-1cc2a2f70f60.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with granite countertops and pendant lights, open to a living area with a sofa and large windows.",
        "public_id": "01a0b66f-66c9-7414-ba30-1cc2a2f70f60",
        "storage_key": "property/6767906449167618/01a0b66f-66c9-7414-ba30-1cc2a2f70f60.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring a large island with a sink and ample counter space, flowing into a bright living room with comfortable seating and scenic views.",
      "link": "false",
      "alt_text": "Modern kitchen island with granite countertops and pendant lights, open to a living area with a sofa and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/21-760 W 46th St-20_final.jpg"
    },
    {
      "id": "ec_1116d4bcc13641fc07558332",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-2365-741d-95a0-94382f27d460.webp",
      "image_media": {
        "alt_text": "Stainless steel refrigerator, wood cabinets, granite countertops, and a stove in a modern kitchen.",
        "public_id": "01a0b66f-2365-741d-95a0-94382f27d460",
        "storage_key": "property/6767906449167618/01a0b66f-2365-741d-95a0-94382f27d460.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen with stainless steel appliances, granite countertops, and ample cabinet space. Perfect for any home chef.",
      "link": "false",
      "alt_text": "Stainless steel refrigerator, wood cabinets, granite countertops, and a stove in a modern kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/22-760 W 46th St-21_final.jpg"
    },
    {
      "id": "ec_3acbdffe38a9919f1a2b9e45",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-66e8-7729-a81e-d7dd8aa484c8.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with granite countertops, stainless steel appliances, and ample cabinet space.",
        "public_id": "01a0b66f-66e8-7729-a81e-d7dd8aa484c8",
        "storage_key": "property/6767906449167618/01a0b66f-66e8-7729-a81e-d7dd8aa484c8.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring a large island, granite countertops, and elegant cabinetry, perfect for entertaining and everyday living.",
      "link": "false",
      "alt_text": "Modern kitchen island with granite countertops, stainless steel appliances, and ample cabinet space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/18-760 W 46th St-17_final.jpg"
    },
    {
      "id": "ec_d62b0ceca19498691bf4c617",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-8144-75de-b256-a0ff5ef34a34.webp",
      "image_media": {
        "alt_text": "Open concept living area with a kitchen island, dining area, and living room.",
        "public_id": "01a0b66f-8144-75de-b256-a0ff5ef34a34",
        "storage_key": "property/6767906449167618/01a0b66f-8144-75de-b256-a0ff5ef34a34.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a modern kitchen with an island, a dining space, and a comfortable living room, perfect for entertaining.",
      "link": "false",
      "alt_text": "Open concept living area with a kitchen island, dining area, and living room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-760 W 46th St-14_final.jpg"
    },
    {
      "id": "ec_dbbeab414639086f1512775b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-6752-7222-835a-5c48cc3e6911.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wood cabinetry.",
        "public_id": "01a0b66f-6752-7222-835a-5c48cc3e6911",
        "storage_key": "property/6767906449167618/01a0b66f-6752-7222-835a-5c48cc3e6911.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, ample cabinet space, and elegant granite countertops. Perfect for preparing meals and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wood cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/20-760 W 46th St-19_final.jpg"
    },
    {
      "id": "ec_cad5ea3072959c54d5ebe62d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-66bf-7205-bd76-b8769b0f71c5.webp",
      "image_media": {
        "alt_text": "A bedroom featuring a ceiling fan, a dresser with abstract art, and a bed with blue and white striped bedding.",
        "public_id": "01a0b66f-66bf-7205-bd76-b8769b0f71c5",
        "storage_key": "property/6767906449167618/01a0b66f-66bf-7205-bd76-b8769b0f71c5.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, complete with a modern ceiling fan and elegant decor.",
      "link": "false",
      "alt_text": "A bedroom featuring a ceiling fan, a dresser with abstract art, and a bed with blue and white striped bedding.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-760 W 46th St-4_final.jpg"
    },
    {
      "id": "ec_7ce0b771abcc6ebe46a612bf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-6fcc-73c8-895c-509566b07d9c.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, ceiling fan, dresser, and large window.",
        "public_id": "01a0b66f-6fcc-73c8-895c-509566b07d9c",
        "storage_key": "property/6767906449167618/01a0b66f-6fcc-73c8-895c-509566b07d9c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom featuring a comfortable king-sized bed, a modern dresser, and a ceiling fan for optimal comfort. Large windows offer ample natural light and a view of the surrounding grounds.",
      "link": "false",
      "alt_text": "Bedroom with a king-sized bed, ceiling fan, dresser, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-760 W 46th St-7_final.jpg"
    },
    {
      "id": "ec_eff088ba741610f0b4361c52",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-72a1-770e-86b5-1486892eb9cb.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a king-size bed, nightstand, dresser, and a ceiling fan.",
        "public_id": "01a0b66f-72a1-770e-86b5-1486892eb9cb",
        "storage_key": "property/6767906449167618/01a0b66f-72a1-770e-86b5-1486892eb9cb.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, featuring a plush king-size bed, elegant nightstand, and a modern dresser. A ceiling fan provides optimal comfort.",
      "link": "false",
      "alt_text": "Cozy bedroom with a king-size bed, nightstand, dresser, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-760 W 46th St-3_final.jpg"
    },
    {
      "id": "ec_e3490caaec47f768baf624ea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-7361-73bf-97f5-860b80ce4af7.webp",
      "image_media": {
        "alt_text": "Interior hallway with three doors and a potted plant",
        "public_id": "01a0b66f-7361-73bf-97f5-860b80ce4af7",
        "storage_key": "property/6767906449167618/01a0b66f-7361-73bf-97f5-860b80ce4af7.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "View of an interior hallway featuring three doors, one of which is slightly ajar, revealing a tiled floor beyond. A lush potted plant adds a touch of greenery to the space, complementing the warm wood flooring.",
      "link": "false",
      "alt_text": "Interior hallway with three doors and a potted plant",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-760 W 46th St-1_final.jpg"
    },
    {
      "id": "ec_ace72514be71df54406306de",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-755e-7469-a35e-0a9ff4e9c17d.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan and a closet",
        "public_id": "01a0b66f-755e-7469-a35e-0a9ff4e9c17d",
        "storage_key": "property/6767906449167618/01a0b66f-755e-7469-a35e-0a9ff4e9c17d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a ceiling fan, a modern dresser with art, and a spacious walk-in closet. This apartment offers comfort and convenience.",
      "link": "false",
      "alt_text": "Bedroom with a ceiling fan and a closet",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-760 W 46th St-5_final.jpg"
    },
    {
      "id": "ec_a3c976498cbf3b31fb5d0042",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-78b7-72f2-abbd-8e5a3acff2e9.webp",
      "image_media": {
        "alt_text": "Closet with hanging clothes and shelves.",
        "public_id": "01a0b66f-78b7-72f2-abbd-8e5a3acff2e9",
        "storage_key": "property/6767906449167618/01a0b66f-78b7-72f2-abbd-8e5a3acff2e9.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious closet with organized shelving and hanging space for your wardrobe.",
      "link": "false",
      "alt_text": "Closet with hanging clothes and shelves.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-760 W 46th St-11_final.jpg"
    },
    {
      "id": "ec_b8459333d5a56adfeaf85995",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-90ef-7124-9c96-9c241452bf3c.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with double sinks and granite countertops, view of toilet and walk-in closet.",
        "public_id": "01a0b66f-90ef-7124-9c96-9c241452bf3c",
        "storage_key": "property/6767906449167618/01a0b66f-90ef-7124-9c96-9c241452bf3c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, a modern light fixture, a toilet, and a walk-in closet.",
      "link": "false",
      "alt_text": "Bathroom vanity with double sinks and granite countertops, view of toilet and walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-760 W 46th St-9_final.jpg"
    },
    {
      "id": "ec_1bd76a8b9d66884146362a51",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-7c67-7099-9f10-9b9abf9550dc.webp",
      "image_media": {
        "alt_text": "Shower and walk-in closet in a bathroom.",
        "public_id": "01a0b66f-7c67-7099-9f10-9b9abf9550dc",
        "storage_key": "property/6767906449167618/01a0b66f-7c67-7099-9f10-9b9abf9550dc.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a spacious walk-in closet and a sleek glass-enclosed shower with tiled walls.",
      "link": "false",
      "alt_text": "Shower and walk-in closet in a bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-760 W 46th St-10_final.jpg"
    },
    {
      "id": "ec_0900b0e968d87863dad52b4b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-98af-7773-8100-5f13da2133a2.webp",
      "image_media": {
        "alt_text": "Bedroom with queen bed, walk-in closet, and ceiling fan.",
        "public_id": "01a0b66f-98af-7773-8100-5f13da2133a2",
        "storage_key": "property/6767906449167618/01a0b66f-98af-7773-8100-5f13da2133a2.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, ample storage in the walk-in closet, and a modern ceiling fan for your comfort.",
      "link": "false",
      "alt_text": "Bedroom with queen bed, walk-in closet, and ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-760 W 46th St-6_final.jpg"
    },
    {
      "id": "ec_dce4c563a3723b4e25f06874",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-9da8-7278-9936-9c9c6e116900.webp",
      "image_media": {
        "alt_text": "Walk-in closet with clothes hanging and folded.",
        "public_id": "01a0b66f-9da8-7278-9936-9c9c6e116900",
        "storage_key": "property/6767906449167618/01a0b66f-9da8-7278-9936-9c9c6e116900.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and hanging space for all your storage needs.",
      "link": "false",
      "alt_text": "Walk-in closet with clothes hanging and folded.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-760 W 46th St-11_final(1).jpg"
    },
    {
      "id": "ec_7e99a110067e879d30cb15b8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-8614-773d-9cfd-a2b7cb0e5ee9.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen-size bed, green throw, ceiling fan, and a wall-mounted TV.",
        "public_id": "01a0b66f-8614-773d-9cfd-a2b7cb0e5ee9",
        "storage_key": "property/6767906449167618/01a0b66f-8614-773d-9cfd-a2b7cb0e5ee9.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, a soothing green throw, and a convenient wall-mounted TV.",
      "link": "false",
      "alt_text": "Modern bedroom with a queen-size bed, green throw, ceiling fan, and a wall-mounted TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/24-760 W 46th St-23_final.jpg"
    },
    {
      "id": "ec_87d238dc68b9deffad241a80",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-a075-736b-8024-ec76adabf7b2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and island seating.",
        "public_id": "01a0b66f-a075-736b-8024-ec76adabf7b2",
        "storage_key": "property/6767906449167618/01a0b66f-a075-736b-8024-ec76adabf7b2.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet space, a large island with granite countertops, and comfortable bar seating.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and island seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/19-760 W 46th St-18_final.jpg"
    },
    {
      "id": "ec_478235ba5e884c9633d4ebc2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-8f76-73c1-9e52-dacca4f23e01.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, nightstands, ceiling fan, and access to the bathroom.",
        "public_id": "01a0b66f-8f76-73c1-9e52-dacca4f23e01",
        "storage_key": "property/6767906449167618/01a0b66f-8f76-73c1-9e52-dacca4f23e01.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a comfortable king-sized bed, modern decor, and a ceiling fan. Enjoy easy access to your private bathroom.",
      "link": "false",
      "alt_text": "Bedroom with a king-sized bed, nightstands, ceiling fan, and access to the bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/23-760 W 46th St-22_final.jpg"
    },
    {
      "id": "ec_78ad4810fbf76522faf00293",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-42ff-71e6-97bc-c00bafee698f.webp",
      "image_media": {
        "alt_text": "Open-concept living area and kitchen with island, white sofa, and dining table.",
        "public_id": "01a0b66f-42ff-71e6-97bc-c00bafee698f",
        "storage_key": "property/6767906449167618/01a0b66f-42ff-71e6-97bc-c00bafee698f.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience spacious and modern living in this open-concept apartment, featuring a gourmet kitchen with an island, a comfortable living area, and a dedicated dining space.",
      "link": "false",
      "alt_text": "Open-concept living area and kitchen with island, white sofa, and dining table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-760 W 46th St-13_final.jpg"
    },
    {
      "id": "ec_b2baa64020fdd292e5bbad73",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-987c-75be-a704-c0b34223a619.webp",
      "image_media": {
        "alt_text": "Kitchen island with bar stools and a breakfast bar",
        "public_id": "01a0b66f-987c-75be-a704-c0b34223a619",
        "storage_key": "property/6767906449167618/01a0b66f-987c-75be-a704-c0b34223a619.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring a large island with seating, granite countertops, and modern appliances. Perfect for entertaining and casual dining.",
      "link": "false",
      "alt_text": "Kitchen island with bar stools and a breakfast bar",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-760 W 46th St-15_final.jpg"
    },
    {
      "id": "ec_6bf28ff7f5da18d71509cb63",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-afc3-756d-ad61-6169a40efcac.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, bedside tables, and access to a bathroom.",
        "public_id": "01a0b66f-afc3-756d-ad61-6169a40efcac",
        "storage_key": "property/6767906449167618/01a0b66f-afc3-756d-ad61-6169a40efcac.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax in the spacious master bedroom, featuring a comfortable king-sized bed, elegant bedside tables, and convenient access to a well-appointed bathroom.",
      "link": "false",
      "alt_text": "Bedroom with a king-sized bed, bedside tables, and access to a bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-760 W 46th St-12_final.jpg"
    },
    {
      "id": "ec_cd5e69f5b099b5453a4f8c06",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-b87d-7096-8370-dbb50a14630f.webp",
      "image_media": {
        "alt_text": "The Dorset monument sign",
        "public_id": "01a0b66f-b87d-7096-8370-dbb50a14630f",
        "storage_key": "property/6767906449167618/01a0b66f-b87d-7096-8370-dbb50a14630f.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Exterior view of The Dorset monument sign, a brick building with manicured bushes in front.",
      "link": "false",
      "alt_text": "The Dorset monument sign",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-760 W 46th St-33.jpg"
    },
    {
      "id": "ec_4bbfff603e221f42694f1379",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-b7e5-76bc-8390-e06b8fe05c79.webp",
      "image_media": {
        "alt_text": "Interior of a community lounge area with sofas, tables, and a small kitchen.",
        "public_id": "01a0b66f-b7e5-76bc-8390-e06b8fe05c79",
        "storage_key": "property/6767906449167618/01a0b66f-b7e5-76bc-8390-e06b8fe05c79.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and unwind in our spacious community lounge, featuring comfortable seating, dining areas, and a convenient kitchen space.",
      "link": "false",
      "alt_text": "Interior of a community lounge area with sofas, tables, and a small kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-760 W 46th St-3.jpg"
    },
    {
      "id": "ec_e1488b2953919a87324d829b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-bfd7-757d-8cea-40682cb01aae.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and an island with seating.",
        "public_id": "01a0b66f-bfd7-757d-8cea-40682cb01aae",
        "storage_key": "property/6767906449167618/01a0b66f-bfd7-757d-8cea-40682cb01aae.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this stylish apartment kitchen, featuring a full suite of stainless steel appliances, ample counter space, and a breakfast bar for casual dining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and an island with seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-760 W 46th St-4.jpg"
    },
    {
      "id": "ec_a0be6fb769ea724ae9253f2f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-ae6b-7679-8a9a-7fe51f7fe54b.webp",
      "image_media": {
        "alt_text": "Rooftop patio with lounge chairs, tables, and greenery.",
        "public_id": "01a0b66f-ae6b-7679-8a9a-7fe51f7fe54b",
        "storage_key": "property/6767906449167618/01a0b66f-ae6b-7679-8a9a-7fe51f7fe54b.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Enjoy the outdoors on our spacious rooftop patio, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Rooftop patio with lounge chairs, tables, and greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-760 W 46th St-7.jpg"
    },
    {
      "id": "ec_94e8014a04ceae75415767ae",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-b72c-71ae-8f9a-84c994ef1bdc.webp",
      "image_media": {
        "alt_text": "Rooftop patio with seating area and city skyline view",
        "public_id": "01a0b66f-b72c-71ae-8f9a-84c994ef1bdc",
        "storage_key": "property/6767906449167618/01a0b66f-b72c-71ae-8f9a-84c994ef1bdc.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Enjoy stunning city views from the comfortable rooftop patio, perfect for relaxing or socializing with friends.",
      "link": "false",
      "alt_text": "Rooftop patio with seating area and city skyline view",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-760 W 46th St-5.jpg"
    },
    {
      "id": "ec_95d13bec75ea9fccddb549d0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-cf6b-7584-b2f3-73779dd3d7c3.webp",
      "image_media": {
        "alt_text": "Rooftop terrace with seating and dining areas, overlooking trees.",
        "public_id": "01a0b66f-cf6b-7584-b2f3-73779dd3d7c3",
        "storage_key": "property/6767906449167618/01a0b66f-cf6b-7584-b2f3-73779dd3d7c3.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy stunning views from the expansive rooftop terrace, featuring comfortable lounge seating and an outdoor dining area perfect for entertaining.",
      "link": "false",
      "alt_text": "Rooftop terrace with seating and dining areas, overlooking trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-760 W 46th St-9.jpg"
    },
    {
      "id": "ec_3fcd8a69b512d617fe6dcea6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-c0a4-776f-9f02-c71716d6ae0a.webp",
      "image_media": {
        "alt_text": "Aerial view of The Dorset apartment building exterior with balconies and surrounding cityscape.",
        "public_id": "01a0b66f-c0a4-776f-9f02-c71716d6ae0a",
        "storage_key": "property/6767906449167618/01a0b66f-c0a4-776f-9f02-c71716d6ae0a.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "An aerial view showcases The Dorset apartment building's modern exterior, complete with private balconies and lush landscaping, set against a backdrop of a vibrant cityscape.",
      "link": "false",
      "alt_text": "Aerial view of The Dorset apartment building exterior with balconies and surrounding cityscape.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-760 W 46th St-12.jpg"
    },
    {
      "id": "ec_feed5fcda3c8a0a54f82bd8c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-f6fb-778d-9f60-b2465ed74c79.webp",
      "image_media": {
        "alt_text": "Aerial view of a city street with apartment buildings and businesses.",
        "public_id": "01a0b66f-f6fb-778d-9f60-b2465ed74c79",
        "storage_key": "property/6767906449167618/01a0b66f-f6fb-778d-9f60-b2465ed74c79.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Experience urban living with this stunning aerial view showcasing the vibrant cityscape, bustling streets, and modern apartment complexes. Discover your new home in the heart of the city.",
      "link": "false",
      "alt_text": "Aerial view of a city street with apartment buildings and businesses.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/310 w 45th st-25 (1).jpg"
    },
    {
      "id": "ec_83d51c564fb4e333c0c1bf74",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-e378-7220-89bc-13441d5c4316.webp",
      "image_media": {
        "alt_text": "Balcony with white couch and dining set overlooking a green lawn and apartment buildings.",
        "public_id": "01a0b66f-e378-7220-89bc-13441d5c4316",
        "storage_key": "property/6767906449167618/01a0b66f-e378-7220-89bc-13441d5c4316.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening drinks on your private balcony, complete with comfortable seating and a dining set. This outdoor space offers a relaxing extension of your apartment living.",
      "link": "false",
      "alt_text": "Balcony with white couch and dining set overlooking a green lawn and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/760 w 46th st-32_final.jpg"
    },
    {
      "id": "ec_7637bb5c9eeadcd1facef297",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-e131-72ce-9b26-4a14ec44d963.webp",
      "image_media": {
        "alt_text": "French doors leading to a patio with a white sofa and plants.",
        "public_id": "01a0b66f-e131-72ce-9b26-4a14ec44d963",
        "storage_key": "property/6767906449167618/01a0b66f-e131-72ce-9b26-4a14ec44d963.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Enjoy your own private outdoor oasis on the patio, perfect for relaxing or entertaining. This space features comfortable seating and lush greenery.",
      "link": "false",
      "alt_text": "French doors leading to a patio with a white sofa and plants.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/30-760 W 46th St-30_final.jpg"
    },
    {
      "id": "ec_9b44347e2dc3aa75bf3c432d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-e2af-757d-a287-65a2abc4f707.webp",
      "image_media": {
        "alt_text": "Balcony with couch overlooking a tree-lined street and apartment buildings.",
        "public_id": "01a0b66f-e2af-757d-a287-65a2abc4f707",
        "storage_key": "property/6767906449167618/01a0b66f-e2af-757d-a287-65a2abc4f707.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Enjoy your morning coffee or evening breeze on your private balcony, with views of the charming street and community.",
      "link": "false",
      "alt_text": "Balcony with couch overlooking a tree-lined street and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/31-760 W 46th St-31_final.jpg"
    },
    {
      "id": "ec_84d561fcf58580cbf06f7baa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66e-e487-74bb-aa70-65334a587d5e.webp",
      "image_media": {
        "alt_text": "Exterior of a multifamily building with a large roll-up garage door.",
        "public_id": "01a0b66e-e487-74bb-aa70-65334a587d5e",
        "storage_key": "property/6767906449167618/01a0b66e-e487-74bb-aa70-65334a587d5e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Exterior view of a modern multifamily property, featuring a large roll-up garage door and surrounding landscaping.",
      "link": "false",
      "alt_text": "Exterior of a multifamily building with a large roll-up garage door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-760 W 46th St-13.jpg"
    },
    {
      "id": "ec_0c14fc7030edb94b4475e331",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-f0c4-7340-85bc-d913a0efc80c.webp",
      "image_media": {
        "alt_text": "Grooming station with professional bathing tub and adjustable grooming table.",
        "public_id": "01a0b66f-f0c4-7340-85bc-d913a0efc80c",
        "storage_key": "property/6767906449167618/01a0b66f-f0c4-7340-85bc-d913a0efc80c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "A dedicated pet grooming area features a stainless steel bathing tub with ramp access and a hydraulic grooming table, perfect for keeping your furry friends clean and pampered.",
      "link": "false",
      "alt_text": "Grooming station with professional bathing tub and adjustable grooming table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-760 W 46th St-14.jpg"
    },
    {
      "id": "ec_705e4aaf6400891a9bfddc1c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-ffa0-7739-b10e-953177ae52ef.webp",
      "image_media": {
        "alt_text": "Pet grooming station with a stainless steel table and tub.",
        "public_id": "01a0b66f-ffa0-7739-b10e-953177ae52ef",
        "storage_key": "property/6767906449167618/01a0b66f-ffa0-7739-b10e-953177ae52ef.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Pamper your furry friends at our convenient on-site pet grooming station, complete with a washing tub and drying station.",
      "link": "false",
      "alt_text": "Pet grooming station with a stainless steel table and tub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-760 W 46th St-1.jpg"
    },
    {
      "id": "ec_e778ce2da25cc9ba962c5b57",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66e-e9c6-7630-a439-d4bfa9ae82a6.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, weight bench, and free weights.",
        "public_id": "01a0b66e-e9c6-7630-a439-d4bfa9ae82a6",
        "storage_key": "property/6767906449167618/01a0b66e-e9c6-7630-a439-d4bfa9ae82a6.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, weight training equipment, and free weights. Stay active and reach your fitness goals without leaving home.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, elliptical, weight bench, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/The-Dorset-41_Photo_Fitness-Center_2026-06-01_Original-Size.jpg"
    },
    {
      "id": "ec_bbcb600ec13ce8df3f9bc2fd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b670-1a65-76cd-a3b9-c4e73f569bad.webp",
      "image_media": {
        "alt_text": "Electric vehicle charging station in a parking garage.",
        "public_id": "01a0b670-1a65-76cd-a3b9-c4e73f569bad",
        "storage_key": "property/6767906449167618/01a0b670-1a65-76cd-a3b9-c4e73f569bad.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Convenient electric vehicle charging stations available for residents in our secure parking garage.",
      "link": "false",
      "alt_text": "Electric vehicle charging station in a parking garage.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/The-Dorset-41_Photo_EV-Charging-Station_2026-06-01_Original-Size.jpg"
    },
    {
      "id": "ec_98e130eea6969d2c20a4d298",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-0c69-768b-b7b9-a018917121c2.webp",
      "image_media": {
        "alt_text": "Aerial view of a city park with surrounding apartment buildings and businesses.",
        "public_id": "01a0b66f-0c69-768b-b7b9-a018917121c2",
        "storage_key": "property/6767906449167618/01a0b66f-0c69-768b-b7b9-a018917121c2.webp",
        "width": 1920,
        "height": 1440
      },
      "title": "Community",
      "description": "Experience urban living with this expansive aerial view showcasing a vibrant city park, surrounded by modern apartment complexes and bustling commercial areas. The perfect blend of nature and city life.",
      "link": "false",
      "alt_text": "Aerial view of a city park with surrounding apartment buildings and businesses.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/The-Dorset-41_Drone-Photo_Neighborhood_Nearby-Attraction_West-Plaza-Area_2026-06-01_Original-Size.jpg"
    },
    {
      "id": "ec_ea6069aa02880aac0e7d6d2d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66e-e9ab-729c-9780-106e0b153c92.webp",
      "image_media": {
        "alt_text": "Spiral bike racks inside a concrete parking garage with arched windows.",
        "public_id": "01a0b66e-e9ab-729c-9780-106e0b153c92",
        "storage_key": "property/6767906449167618/01a0b66e-e9ab-729c-9780-106e0b153c92.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Secure your bike in our convenient on-site bike racks located within the parking garage.",
      "link": "false",
      "alt_text": "Spiral bike racks inside a concrete parking garage with arched windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/The-Dorset-41_Photo_Bike-Racks_2026-06-01_Original-Size.jpg"
    },
    {
      "id": "ec_9e4cb3278495dcc9eb772ab1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b670-0c3a-724b-ba67-0ff67f4676e7.webp",
      "image_media": {
        "alt_text": "Package concierge lockers in building lobby",
        "public_id": "01a0b670-0c3a-724b-ba67-0ff67f4676e7",
        "storage_key": "property/6767906449167618/01a0b670-0c3a-724b-ba67-0ff67f4676e7.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Secure package lockers available for resident convenience.",
      "link": "false",
      "alt_text": "Package concierge lockers in building lobby",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/The-Dorset-41_Photo_Parcel-Package-Lockers_2026-06-01_Original-Size.jpg"
    },
    {
      "id": "ec_0eacbb62738b36b6d094f37f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b670-1427-7159-961e-e55864842ad2.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertop and walk-in closet.",
        "public_id": "01a0b670-1427-7159-961e-e55864842ad2",
        "storage_key": "property/6767906449167618/01a0b670-1427-7159-961e-e55864842ad2.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bathroom with a modern vanity and a convenient walk-in closet.",
      "link": "false",
      "alt_text": "Bathroom vanity with granite countertop and walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/The-Dorset-41_Photo_Guest-Suite-Bathroom_Angle-2_2026-06-01_Original-Size.jpg"
    },
    {
      "id": "ec_00cbaa97dd82d5318ede39e3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b670-1d57-76fb-8410-0db1a243123a.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, chair, and TV.",
        "public_id": "01a0b670-1d57-76fb-8410-0db1a243123a",
        "storage_key": "property/6767906449167618/01a0b670-1d57-76fb-8410-0db1a243123a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "A beautifully appointed bedroom featuring a queen-size bed, a comfortable seating area, and modern entertainment amenities.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, chair, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/The-Dorset-41_Photo_Guest-Suite-Bedroom_Angle-1_2026-06-01_Original-Size.jpg"
    },
    {
      "id": "ec_21b43f66af171ca298a51f13",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66f-0a37-7379-a163-ecbf8ea12135.webp",
      "image_media": {
        "alt_text": "Aerial view of Saint Luke's Hospital campus with surrounding cityscape",
        "public_id": "01a0b66f-0a37-7379-a163-ecbf8ea12135",
        "storage_key": "property/6767906449167618/01a0b66f-0a37-7379-a163-ecbf8ea12135.webp",
        "width": 1920,
        "height": 1440
      },
      "title": "Community",
      "description": "An aerial view of the Saint Luke's Hospital campus showcases its modern architecture, green spaces, and integration into the urban environment.",
      "link": "false",
      "alt_text": "Aerial view of Saint Luke's Hospital campus with surrounding cityscape",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/The-Dorset-41_Drone-Photo_Neighborhood_Nearby-Attraction_St-Lukes-Hospital_2026-06-01_Original-Size.jpg"
    },
    {
      "id": "ec_80e9cc1c38e75f2655498c04",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66e-d135-75d9-ab43-2dc802a2f155.webp",
      "image_media": {
        "alt_text": "Interior mailboxes with artwork above.",
        "public_id": "01a0b66e-d135-75d9-ab43-2dc802a2f155",
        "storage_key": "property/6767906449167618/01a0b66e-d135-75d9-ab43-2dc802a2f155.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Secure interior mailboxes for residents, decorated with framed cityscapes.",
      "link": "false",
      "alt_text": "Interior mailboxes with artwork above.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/The-Dorset-41_Photo_Mailboxes_2026-06-01_Original-Size.jpg"
    },
    {
      "id": "ec_b845cd5e0c50d08cec33003d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b670-1db7-71af-94af-5fea93d49141.webp",
      "image_media": {
        "alt_text": "Kitchenette and hallway with a bed visible in the background.",
        "public_id": "01a0b670-1db7-71af-94af-5fea93d49141",
        "storage_key": "property/6767906449167618/01a0b670-1db7-71af-94af-5fea93d49141.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "This apartment features a compact kitchenette with granite countertops, ample cabinet space, a microwave, sink, and dishwasher. A hallway leads to the bedroom, which is visible in the background.",
      "link": "false",
      "alt_text": "Kitchenette and hallway with a bed visible in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/The-Dorset-41_Photo_Guest-Suite-Entrance_Kitchen_2026-06-01_Original-Size.jpg"
    },
    {
      "id": "ec_32d28ae5b79c822ccc5a58b8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66e-f2e8-70eb-a508-80b9376f656e.webp",
      "image_media": {
        "alt_text": "Lounge chairs on a rooftop deck with trees and city skyline in the background.",
        "public_id": "01a0b66e-f2e8-70eb-a508-80b9376f656e",
        "storage_key": "property/6767906449167618/01a0b66e-f2e8-70eb-a508-80b9376f656e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax on the rooftop deck with comfortable lounge chairs and enjoy the scenic views of the city and surrounding trees.",
      "link": "false",
      "alt_text": "Lounge chairs on a rooftop deck with trees and city skyline in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/The-Dorset-41_Photo_Rooftop-Patio_Lounge-Chairs_2026-06-01_Original-Size.jpg"
    },
    {
      "id": "ec_0e6a64e54645482b9dbf2c68",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b670-3511-7756-b9be-3233db9dd38c.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a walk-in shower, vanity, and toilet.",
        "public_id": "01a0b670-3511-7756-b9be-3233db9dd38c",
        "storage_key": "property/6767906449167618/01a0b670-3511-7756-b9be-3233db9dd38c.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom, featuring a spacious walk-in shower with elegant tilework, a granite-topped vanity with ample storage, and a modern toilet.",
      "link": "false",
      "alt_text": "Modern bathroom with a walk-in shower, vanity, and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/The-Dorset-41_Photo_Guest-Suite-Bathroom_Angle-1_2026-06-01_Original-Size.jpg"
    },
    {
      "id": "ec_d9e1d99f5fcd6ebbe395d798",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66e-f2e6-751c-ad22-c1ed7b1bb275.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, TV, and an armchair.",
        "public_id": "01a0b66e-f2e6-751c-ad22-c1ed7b1bb275",
        "storage_key": "property/6767906449167618/01a0b66e-f2e6-751c-ad22-c1ed7b1bb275.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, a dresser with a mounted TV, and a cozy armchair, perfect for relaxation.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, dresser, TV, and an armchair.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/The-Dorset-41_Photo_Guest-Suite-Bedroom_Angle-2_2026-06-01_Original-Size.jpg"
    },
    {
      "id": "ec_1cd28d82a263317c30b800dd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66e-d3bf-7708-91d3-1f757ab20349.webp",
      "image_media": {
        "alt_text": "Hallway with elevator doors, a cabinet with decor, and two doors.",
        "public_id": "01a0b66e-d3bf-7708-91d3-1f757ab20349",
        "storage_key": "property/6767906449167618/01a0b66e-d3bf-7708-91d3-1f757ab20349.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Community",
      "description": "Step into comfort with this inviting hallway featuring a modern elevator, elegant decor, and convenient access to your apartment.",
      "link": "false",
      "alt_text": "Hallway with elevator doors, a cabinet with decor, and two doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/The-Dorset-41_Photo_Elevator_2026-06-01_Original-Size.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_71e722bb-2d0e-48c2-b215-4b52b22c5ed7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "True Food Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "4749 Pennsylvania Ave, Kansas City, MO 64112, USA",
      "poi_short_description": "Relaxed, eco-chic chain serving health-conscious fare, including vegan options, plus cocktails.",
      "poi_long_description": "Relaxed, eco-chic chain serving health-conscious fare, including vegan options, plus cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66c-159a-72cf-8005-a59305c8d20e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-159a-72cf-8005-a59305c8d20e",
        "storage_key": "property/6767906449167618/01a0b66c-159a-72cf-8005-a59305c8d20e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.truefoodkitchen.com/locations/kansas-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16524964701387735684&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "true-food-kitchen",
      "poi_latitude": "39.040465",
      "poi_longitude": "-94.593679",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-931-4947",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-867e9755c20e",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJacMxe97vwIcRhMIVyNd3VOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7d1cf345-c2b2-41bf-b963-aae55493433d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Jack Stack Barbecue - Plaza",
      "poi_type": "Restaurants",
      "poi_address": "4747 Wyandotte St, Kansas City, MO 64112, USA",
      "poi_short_description": "Bustling local chain known for its vast barbecue menu encompassing steak, seafood, and more.",
      "poi_long_description": "Bustling local chain known for its vast barbecue menu encompassing steak, seafood, and more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc992-59b7-718c-bac7-24ec200307ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-59b7-718c-bac7-24ec200307ae",
        "storage_key": "property/6767906449167618/019fc992-59b7-718c-bac7-24ec200307ae.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.jackstackbbq.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=497015801065317704&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack-stack-barbecue---plaza",
      "poi_latitude": "39.0412556",
      "poi_longitude": "-94.5886417",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-531-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-867e9755c20e",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGYjixLjvwIcRSCVB3jzB5QY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_6c15520f-90b3-45bd-acef-9023f7bed465",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "The Capital Grille",
      "poi_type": "Restaurants",
      "poi_address": "4760 Broadway St, Kansas City, MO 64112, USA",
      "poi_short_description": "Outpost of the upscale steakhouse chain offers classic American fare & a clubby, refined setting.",
      "poi_long_description": "Outpost of the upscale steakhouse chain offers classic American fare & a clubby, refined setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc991-4967-726f-84ff-ee7b3b86f6f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-4967-726f-84ff-ee7b3b86f6f0",
        "storage_key": "property/6767906449167618/019fc991-4967-726f-84ff-ee7b3b86f6f0.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.thecapitalgrille.com/locations/mo/kansas-city/kansas-city/8064?cmpid=br:tcg_ag:ie_ch:loc_ca:TCGGMB_sn:gmb_gt:kansas-city-mo-8064_pl:locurl_rd:1057",
      "poi_directions_map_url": "https://maps.google.com/?cid=2807510319733172306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-capital-grille",
      "poi_latitude": "39.0406968",
      "poi_longitude": "-94.5919504",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-531-8345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-867e9755c20e",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgYcJpLfvwIcRUmjwzsJH9iY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "custom_8f1a2df2-bad0-482d-a7df-5d921ebc03dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "The Classic Cup Cafe",
      "poi_type": "Restaurants",
      "poi_address": "301 W 47th St, Kansas City, MO 64112, USA",
      "poi_short_description": "Casual staple providing an extensive menu of American cooking, plus outdoor seating.",
      "poi_long_description": "Casual staple providing an extensive menu of American cooking, plus outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66c-1479-746e-8b10-d1bb3d035f25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-1479-746e-8b10-d1bb3d035f25",
        "storage_key": "property/6767906449167618/01a0b66c-1479-746e-8b10-d1bb3d035f25.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://theclassiccupcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15530999025163790290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-classic-cup-cafe",
      "poi_latitude": "39.0421573",
      "poi_longitude": "-94.5908287",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-753-1840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a4-b8b4-76da-acbf-6fd7030f67d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-b8b4-76da-acbf-6fd7030f67d9",
        "storage_key": "property/6767906449167618/019ff6a4-b8b4-76da-acbf-6fd7030f67d9.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJD7E2WbjvwIcR0mfTnVMxidc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_e1c25894-476c-428f-bb23-f669a4e25b65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "McCormick & Schmick's Seafood & Steaks",
      "poi_type": "Restaurants",
      "poi_address": "448 W 47th St, Kansas City, MO 64112, USA",
      "poi_short_description": "Upscale steak & seafood chain known for its clubby environs & happy hour.",
      "poi_long_description": "Upscale steak & seafood chain known for its clubby environs & happy hour.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66c-0b70-71e5-9336-85b546dd7e33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-0b70-71e5-9336-85b546dd7e33",
        "storage_key": "property/6767906449167618/01a0b66c-0b70-71e5-9336-85b546dd7e33.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.mccormickandschmicks.com/location/mccormick-schmicks-kansas-city-mo/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17792790613339746772&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mccormick--schmicks-seafood--steaks",
      "poi_latitude": "39.0426046",
      "poi_longitude": "-94.5932546",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-531-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-867e9755c20e",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxfqiCbjvwIcR1DEF58qw7PY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_960516d1-c69c-4a2c-a8b7-e6df0fc61d6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "4701 Wyandotte St, Kansas City, MO 64112, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a4-5b17-726b-ac92-69e1f1826e3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-5b17-726b-ac92-69e1f1826e3f",
        "storage_key": "property/6767906449167618/019ff6a4-5b17-726b-ac92-69e1f1826e3f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/mo/kansas-city-17.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=18256206695721676157&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "39.0420206",
      "poi_longitude": "-94.5886929",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-960-1919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-867e9755c20e",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPxDuyLjvwIcRfS2ZpEMTW_0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_d75c411f-2fd1-421c-8a96-44b45fdca1cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Fogo de Chão Brazilian Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "222 W 47th St, Kansas City, MO 64112, USA",
      "poi_short_description": "Upscale Brazilian chain for all-you-can-eat meat carved tableside plus an extensive salad bar.",
      "poi_long_description": "Upscale Brazilian chain for all-you-can-eat meat carved tableside plus an extensive salad bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a4-52c8-7518-8197-6aa5f72b311c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-52c8-7518-8197-6aa5f72b311c",
        "storage_key": "property/6767906449167618/019ff6a4-52c8-7518-8197-6aa5f72b311c.webp",
        "width": 1280,
        "height": 779
      },
      "poi_business_url": "https://fogodechao.com/location/kansas-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7229289636537500349&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fogo-de-cho-brazilian-steakhouse",
      "poi_latitude": "39.042487",
      "poi_longitude": "-94.5899538",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-931-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-867e9755c20e",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNzU0krjvwIcRvQI7PJ-YU2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brazilian_restaurant"
    },
    {
      "id": "custom_470973ac-4370-4e75-b171-910998560d1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Buca di Beppo Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "310 W 47th St, Kansas City, MO 64112, USA",
      "poi_short_description": "Chain serving family-style Italian fare in a kitschy setting featuring red-&-white tablecloths.",
      "poi_long_description": "Chain serving family-style Italian fare in a kitschy setting featuring red-&-white tablecloths.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66c-0b28-7156-b3e1-ef224aaab480.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-0b28-7156-b3e1-ef224aaab480",
        "storage_key": "property/6767906449167618/01a0b66c-0b28-7156-b3e1-ef224aaab480.webp",
        "width": 1280,
        "height": 849
      },
      "poi_business_url": "https://dineatbuca.com/locations/kansas-city-plaza/?utm_campaign=local&utm_source=gbp&utm_medium=organic&utm_content=kansas-city-plaza",
      "poi_directions_map_url": "https://maps.google.com/?cid=1703193005416521739&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buca-di-beppo-italian-restaurant",
      "poi_latitude": "39.0425894",
      "poi_longitude": "-94.5906364",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-931-6548",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-867e9755c20e",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA0-NibjvwIcRCyDItwP1ohc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_1792859d-024b-485b-b04e-2eaac1f19377",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Cooper’s Hawk Winery & Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "4686 Broadway Blvd, Kansas City, MO 64112, USA",
      "poi_short_description": "Upscale chain serving New American fare paired with house-label  wines in a contemporary setting.",
      "poi_long_description": "Upscale chain serving New American fare paired with house-label  wines in a contemporary setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66c-101a-7629-a0e2-afdea43c4b9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-101a-7629-a0e2-afdea43c4b9a",
        "storage_key": "property/6767906449167618/01a0b66c-101a-7629-a0e2-afdea43c4b9a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chwinery.com/locations/missouri/kansas-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=2055704043232815561&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coopers-hawk-winery--restaurant",
      "poi_latitude": "39.042566",
      "poi_longitude": "-94.5917549",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-531-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-867e9755c20e",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ebQbrjvwIcRyek5jO9Thxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_84ab5ad5-9e69-4b00-a783-5401c00850c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Eddie V's Prime Seafood",
      "poi_type": "Restaurants",
      "poi_address": "700 W 47th St Ste 115, Kansas City, MO 64112, USA",
      "poi_short_description": "Elegant fine-dining chain with a seafood & steak menu, plus a cocktail lounge featuring live jazz",
      "poi_long_description": "Elegant fine-dining chain with a seafood & steak menu, plus a cocktail lounge featuring live jazz",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc991-41a6-732e-8d0d-abe2978df3a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-41a6-732e-8d0d-abe2978df3a9",
        "storage_key": "property/6767906449167618/019fc991-41a6-732e-8d0d-abe2978df3a9.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://www.eddiev.com/locations/mo/kansas-city/kansas-city/8517?cmpid=br:ev_ag:ie_ch:loc_ca:EVGMB_sn:gmb_gt:kansas-city-mo-8517_pl:locurl_rd:1016",
      "poi_directions_map_url": "https://maps.google.com/?cid=9632121288401222020&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eddie-vs-prime-seafood",
      "poi_latitude": "39.0426462",
      "poi_longitude": "-94.5953413",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-531-2537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-867e9755c20e",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqb6127fvwIcRhPmhVEcrrIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_91d4943c-0091-4203-81e5-947e8046c8ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Gram & Dun",
      "poi_type": "Restaurants",
      "poi_address": "600 Ward Pkwy, Kansas City, MO 64112, USA",
      "poi_short_description": "Buzzy venue serving innovative American cuisine in a swanky but warm setting with patio seating.",
      "poi_long_description": "Buzzy venue serving innovative American cuisine in a swanky but warm setting with patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a4-6410-76a8-bf2f-aa61cac6499f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-6410-76a8-bf2f-aa61cac6499f",
        "storage_key": "property/6767906449167618/019ff6a4-6410-76a8-bf2f-aa61cac6499f.webp",
        "width": 1280,
        "height": 917
      },
      "poi_business_url": "http://gramanddun.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10690610804177532125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gram--dun",
      "poi_latitude": "39.0403087",
      "poi_longitude": "-94.5940799",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-389-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-867e9755c20e",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu3HCerfvwIcR3XT0luKtXJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_38efdd49-f064-4190-9633-738cd5e3825b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Shake Shack Country Club Plaza",
      "poi_type": "Restaurants",
      "poi_address": "239 W 47th St, Kansas City, MO 64112, USA",
      "poi_short_description": "Hip, counter-serve chain for gourmet takes on fast-food classics like burgers & frozen custard.",
      "poi_long_description": "Hip, counter-serve chain for gourmet takes on fast-food classics like burgers & frozen custard.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66c-0e12-7061-97ed-112abbb5ea30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-0e12-7061-97ed-112abbb5ea30",
        "storage_key": "property/6767906449167618/01a0b66c-0e12-7061-97ed-112abbb5ea30.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.shakeshack.com/location/country-club-plaza-mo?utm_source=google&utm_medium=listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=8089810030736374722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shake-shack-country-club-plaza",
      "poi_latitude": "39.0420483",
      "poi_longitude": "-94.5903838",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-708-4030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-867e9755c20e",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSUTiT3DvwIcRwvtuflzHRHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_9f7d7308-b0bc-43cc-8b9f-ff84795a430f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Chuy's",
      "poi_type": "Restaurants",
      "poi_address": "209 W 46th Terrace, Kansas City, MO 64112, USA",
      "poi_short_description": "Chain serving \"big as yo' face\" burritos & other Tex-Mex dishes in kitschy, eclectic settings.",
      "poi_long_description": "Chain serving \"big as yo' face\" burritos & other Tex-Mex dishes in kitschy, eclectic settings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66c-1466-76ab-8627-e0a8c6ad1978.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-1466-76ab-8627-e0a8c6ad1978",
        "storage_key": "property/6767906449167618/01a0b66c-1466-76ab-8627-e0a8c6ad1978.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chuys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16252003617320799033&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chuys",
      "poi_latitude": "39.0430438",
      "poi_longitude": "-94.5886585",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-931-2783",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-867e9755c20e",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZRbCrbjvwIcROQvF4i63iuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "custom_a82f4ccd-f6d5-4f9e-a9b6-f39801e3f117",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Kona Grill - Kansas City",
      "poi_type": "Restaurants",
      "poi_address": "444 Ward Pkwy, Kansas City, MO 64112, USA",
      "poi_short_description": "Sleek chain with a broad New American menu including low-calorie options, plus sushi & cocktails.",
      "poi_long_description": "Sleek chain with a broad New American menu including low-calorie options, plus sushi & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a4-66bf-74ff-b6e7-377e9498690f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-66bf-74ff-b6e7-377e9498690f",
        "storage_key": "property/6767906449167618/019ff6a4-66bf-74ff-b6e7-377e9498690f.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://konagrill.com/locations?locations=Kansas-City,64112",
      "poi_directions_map_url": "https://maps.google.com/?cid=12026659563910578359&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kona-grill---kansas-city",
      "poi_latitude": "39.0405473",
      "poi_longitude": "-94.5931112",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-931-5888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-867e9755c20e",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX-ddzrnvwIcRt8BxRSdH56Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_2106d956-2007-41e3-9e2a-f778b1088173",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Town Topic Hamburgers BROADWAY",
      "poi_type": "Restaurants",
      "poi_address": "2021 Broadway Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "Venerable restaurant (since the 1930s) serving burgers, shakes and pies in a hole-in-the-wall setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66c-10d6-7339-b2d7-716f5e033cd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-10d6-7339-b2d7-716f5e033cd6",
        "storage_key": "property/6767906449167618/01a0b66c-10d6-7339-b2d7-716f5e033cd6.webp",
        "width": 1280,
        "height": 706
      },
      "poi_business_url": "http://towntopic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14985971370995172736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town-topic-hamburgers-broadway",
      "poi_latitude": "39.0884514",
      "poi_longitude": "-94.5888061",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-842-2298",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-867e9755c20e",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-867e9755c20e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ69u-z0bwwIcRgEVXFpDd-M8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_7dae9710-be51-4ea1-8037-098c50bc595a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Cosentino's Sun Fresh Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4001 Mill St, Kansas City, MO 64111, USA",
      "poi_short_description": "Supermarket offering produce, prepared foods, and organic products, plus a pharmacy, a florist, and a liquor store.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a4-6fb7-74db-b97d-262d01cff35d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-6fb7-74db-b97d-262d01cff35d",
        "storage_key": "property/6767906449167618/019ff6a4-6fb7-74db-b97d-262d01cff35d.webp",
        "width": 1280,
        "height": 679
      },
      "poi_business_url": "https://cosentinos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9583179988153697737&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cosentinos-sun-fresh-market",
      "poi_latitude": "39.054676",
      "poi_longitude": "-94.594949",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-931-1639",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-8d4891d9dfae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-8d4891d9dfae",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-8d4891d9dfae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcHUGdDvwIcRyYWI5GxL_oQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1b3ab9da-e6fa-4c3c-9944-21afe9d5bef5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Nature's Own Health Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1020 Westport Rd, Kansas City, MO 64111, USA",
      "poi_short_description": "Small market selling produce, grains and other health foods, plus cosmetics and beer.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0100a-cde4-776d-a614-c58be588f9a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-cde4-776d-a614-c58be588f9a2",
        "storage_key": "property/6767906449167618/01a0100a-cde4-776d-a614-c58be588f9a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://naturesownmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7663941239630566377&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "natures-own-health-market",
      "poi_latitude": "39.0503429",
      "poi_longitude": "-94.5992904",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-997-9420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-8d4891d9dfae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-8d4891d9dfae",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-8d4891d9dfae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJccdqMMzvwIcR6ZOlv_PJW2o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e6f80078-ce15-44cc-ac93-051ebf083050",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5011 Main St, Kansas City, MO 64112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc992-4e65-7109-b8c9-2cdaa4d4025a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-4e65-7109-b8c9-2cdaa4d4025a",
        "storage_key": "property/6767906449167618/019fc992-4e65-7109-b8c9-2cdaa4d4025a.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/kansas-city-mo-pharmacies/5011-main-st-kansas-city-mo-64112/storeid=8567?WT.mc_id=LS_GOOGLE_RX_8567",
      "poi_directions_map_url": "https://maps.google.com/?cid=3971086833944145163&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "39.0360143",
      "poi_longitude": "-94.5871235",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-531-4699",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a4-b8b4-76da-acbf-70ffb167fd27.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-b8b4-76da-acbf-70ffb167fd27",
        "storage_key": "property/6767906449167618/019ff6a4-b8b4-76da-acbf-70ffb167fd27.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ07UGXrzvwIcRC614jW8iHDc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_aa63dbde-04bc-4318-b644-08bc7554fa8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "QuikTrip",
      "poi_type": "Transportation & Transit",
      "poi_address": "4327 Main St, Kansas City, MO 64111, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a4-6fc2-766f-a1bc-0cd8393f2353.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-6fc2-766f-a1bc-0cd8393f2353",
        "storage_key": "property/6767906449167618/019ff6a4-6fc2-766f-a1bc-0cd8393f2353.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/mo/kansas-city/4327-main-st?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDM4OTUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17083067599000984769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "39.0483113",
      "poi_longitude": "-94.5860044",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-561-6055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a4-b8c2-7417-85a2-5b71e35f89f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-b8c2-7417-85a2-5b71e35f89f8",
        "storage_key": "property/6767906449167618/019ff6a4-b8c2-7417-85a2-5b71e35f89f8.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJjVJIesHvwIcRwVxwqHg_E-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_a6173eda-6988-40b1-95c8-dde72f2a5960",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Whole foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "301 E 51st St, Kansas City, MO 64112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66c-1c03-756a-af71-d826e53fcfcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-1c03-756a-af71-d826e53fcfcc",
        "storage_key": "property/6767906449167618/01a0b66c-1c03-756a-af71-d826e53fcfcc.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/kansascity",
      "poi_directions_map_url": "https://maps.google.com/?cid=8698117794034062261&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "39.0344601",
      "poi_longitude": "-94.583645",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-708-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-8d4891d9dfae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-8d4891d9dfae",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-8d4891d9dfae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT-FpdgDvwIcRtZPnjwzstXg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_246b19a0-cfb3-4455-ad63-d0c2bcd930a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Made in KC Marketplace - Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "306 W 47th St, Kansas City, MO 64112, USA",
      "poi_short_description": "Shops featuring locally sourced goods, including T-shirts, hats and home decor, plus a cafe and bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc993-727b-734d-9dc4-38439a22078b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-727b-734d-9dc4-38439a22078b",
        "storage_key": "property/6767906449167618/019fc993-727b-734d-9dc4-38439a22078b.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.madeinkc.co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12340124857014094327&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "made-in-kc-marketplace---plaza",
      "poi_latitude": "39.0426967",
      "poi_longitude": "-94.5905537",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-718-0806",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-8915de63e368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-8915de63e368",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-8915de63e368.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJYXq_NPvwIcR9wlLOi3uQKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gift_shop"
    },
    {
      "id": "custom_2b8a7aea-d206-4bac-8148-ae2871901c6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Country Club Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "4706 Broadway Blvd, Kansas City, MO 64112, USA",
      "poi_short_description": "Sprawling shopping area made up of Moorish-themed buildings housing stores & restaurants.",
      "poi_long_description": "Sprawling shopping area made up of Moorish-themed buildings housing stores & restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98b-4c2c-77ea-891f-db38f9327313.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98b-4c2c-77ea-891f-db38f9327313",
        "storage_key": "property/6767906449167618/019fc98b-4c2c-77ea-891f-db38f9327313.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://countryclubplaza.com/?utm_source=GoogleMyBusiness&utm_medium=Organic&utm_campaign=GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=12339093817016807577&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "country-club-plaza",
      "poi_latitude": "39.0419692",
      "poi_longitude": "-94.5926089",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-753-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-8915de63e368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-8915de63e368",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-8915de63e368.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJr4r_377vwIcRmXCBhXNEPas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f5cd6fc5-f165-44e9-965f-c477f5e849f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Cosentino's Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "14 W 62 Terrace, Kansas City, MO 64113, USA",
      "poi_short_description": "Relaxed supermarket selling organic eats, baked goods, wine and prepared dishes, with a salad bar, plus helpful staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a4-785f-77be-bfc2-7e9e5d86e9c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-785f-77be-bfc2-7e9e5d86e9c4",
        "storage_key": "property/6767906449167618/019ff6a4-785f-77be-bfc2-7e9e5d86e9c4.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "http://cosentinos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13117215859270891575&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cosentinos-market",
      "poi_latitude": "39.0150001",
      "poi_longitude": "-94.5888037",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-523-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-8d4891d9dfae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-8d4891d9dfae",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-8d4891d9dfae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVYPViQ7vwIcRNzj2dVO2CbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e30b9764-dd8d-4ff4-9797-545ddf3a6409",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Cosentino's Price Chopper",
      "poi_type": "Shopping & Retail",
      "poi_address": "6327 Brookside Plaza, Kansas City, MO 64113, USA",
      "poi_short_description": "Urban grocery store offering produce, meats and baked goods along with beer and wine.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc993-5d22-77b6-b3a3-753966303548.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-5d22-77b6-b3a3-753966303548",
        "storage_key": "property/6767906449167618/019fc993-5d22-77b6-b3a3-753966303548.webp",
        "width": 1280,
        "height": 824
      },
      "poi_business_url": "https://www.mypricechopper.com/store-details?storeId=82",
      "poi_directions_map_url": "https://maps.google.com/?cid=5601713248782007001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cosentinos-price-chopper",
      "poi_latitude": "39.01302250000001",
      "poi_longitude": "-94.5903738",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-523-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-8d4891d9dfae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-8d4891d9dfae",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-8d4891d9dfae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXbd8NA7vwIcR2TpAR4VIvU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_7e3acff4-7d64-49b1-95de-2aa3fd182d26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "University of Missouri-Kansas City",
      "poi_type": "Education",
      "poi_address": "5000 Holmes St, Kansas City, MO 64110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98b-5ca7-76db-8fed-774e5d715d0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98b-5ca7-76db-8fed-774e5d715d0a",
        "storage_key": "property/6767906449167618/019fc98b-5ca7-76db-8fed-774e5d715d0a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.umkc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10660093312754521544&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-missouri-kansas-city",
      "poi_latitude": "39.0333035",
      "poi_longitude": "-94.577545",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-235-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-91cb1aec8d8f",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ856Hn5DvwIcRyBVAa2NC8JM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0bb7e315-5e00-4f00-a17d-6a60b17e631d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Kansas City Art Institute",
      "poi_type": "Education",
      "poi_address": "4415 Warwick Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc992-d143-718d-be0b-64a42646cdeb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-d143-718d-be0b-64a42646cdeb",
        "storage_key": "property/6767906449167618/019fc992-d143-718d-be0b-64a42646cdeb.webp",
        "width": 705,
        "height": 670
      },
      "poi_business_url": "http://www.kcai.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3056374416396262313&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-art-institute",
      "poi_latitude": "39.0466734",
      "poi_longitude": "-94.5834059",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-472-4852",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-91cb1aec8d8f",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJffVj1cHvwIcRqRvknVZsaio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_02856f0a-74b0-4315-9cc6-3c0e8d4eab6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Rockhurst University",
      "poi_type": "Education",
      "poi_address": "1100 Rockhurst Rd, Kansas City, MO 64110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98b-566c-7409-b2f4-59947f805b46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98b-566c-7409-b2f4-59947f805b46",
        "storage_key": "property/6767906449167618/019fc98b-566c-7409-b2f4-59947f805b46.webp",
        "width": 960,
        "height": 320
      },
      "poi_business_url": "https://www.rockhurst.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16644960823377639958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockhurst-university",
      "poi_latitude": "39.0303478",
      "poi_longitude": "-94.5710674",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-501-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-91cb1aec8d8f",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU6rD5oTvwIcRFrq3Ga7H_uY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e153e203-1611-4db7-806a-c48c725331ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Pembroke Hill School - Wornall Campus",
      "poi_type": "Education",
      "poi_address": "400 W 51st St, Kansas City, MO 64112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc992-ff5e-74be-9f05-7c7706147a50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-ff5e-74be-9f05-7c7706147a50",
        "storage_key": "property/6767906449167618/019fc992-ff5e-74be-9f05-7c7706147a50.webp",
        "width": 1168,
        "height": 694
      },
      "poi_business_url": "http://www.pembrokehill.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14098303887516842814&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pembroke-hill-school---wornall-campus",
      "poi_latitude": "39.0358206",
      "poi_longitude": "-94.5931862",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-936-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-91cb1aec8d8f",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdYvScLrvwIcRPjvzjrA8p8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_f2252c46-a151-4076-93c0-82dd20ebefbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "St. Paul's Episcopal Day School",
      "poi_type": "Education",
      "poi_address": "4041 Main St, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a4-9225-733b-b022-cb3c2f5fadc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-9225-733b-b022-cb3c2f5fadc3",
        "storage_key": "property/6767906449167618/019ff6a4-9225-733b-b022-cb3c2f5fadc3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.speds.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11502626485585069936&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-pauls-episcopal-day-school",
      "poi_latitude": "39.05294019999999",
      "poi_longitude": "-94.5857695",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-931-8614",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-91cb1aec8d8f",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY_u7L8PvwIcRcEdMWdiJoZ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_19000997-a496-4ede-8b13-7a45c5eff623",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "St. Teresa's Academy",
      "poi_type": "Education",
      "poi_address": "5600 Main St, Kansas City, MO 64113, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0100a-de58-70a9-9694-35381e118f7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-de58-70a9-9694-35381e118f7f",
        "storage_key": "property/6767906449167618/01a0100a-de58-70a9-9694-35381e118f7f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://stteresasacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14340484779120538902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-teresas-academy",
      "poi_latitude": "39.0257355",
      "poi_longitude": "-94.5882839",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-501-0011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-91cb1aec8d8f",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS97r2qbvwIcRFjVgbu2iA8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_cee693e8-faa5-4e5d-8bdb-3078fd3f1bbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Rockhurst High School",
      "poi_type": "Education",
      "poi_address": "9301 State Line Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66c-1c48-77fe-9dc1-a6d187e02648.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-1c48-77fe-9dc1-a6d187e02648",
        "storage_key": "property/6767906449167618/01a0b66c-1c48-77fe-9dc1-a6d187e02648.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.rockhursths.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11916027818988459788&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockhurst-high-school",
      "poi_latitude": "38.9602018",
      "poi_longitude": "-94.6069495",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 816-363-2036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-91cb1aec8d8f",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPahAHiDpwIcRDNd65Co8XqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_1962fcd7-f689-41d9-a39b-a3c0fb20a6c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Primitivo Garcia Elementary School",
      "poi_type": "Education",
      "poi_address": "1000 W 17 St, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66c-1ca9-74df-9bdf-8afda8c00ccc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-1ca9-74df-9bdf-8afda8c00ccc",
        "storage_key": "property/6767906449167618/01a0b66c-1ca9-74df-9bdf-8afda8c00ccc.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://primitivogarcia.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10435885958455630198&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primitivo-garcia-elementary-school",
      "poi_latitude": "39.0942702",
      "poi_longitude": "-94.595658",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-418-8725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-91cb1aec8d8f",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGVAkzU_wwIcRdhk8zvy205A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_43cb3c2a-68d7-4ead-99f7-b6d2a881930b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Central Middle School",
      "poi_type": "Education",
      "poi_address": "3611 Linwood Blvd, Kansas City, MO 64128, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://cms.kcpublicschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8515785785350605707&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-middle-school",
      "poi_latitude": "39.0668504",
      "poi_longitude": "-94.5402564",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 816-418-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-91cb1aec8d8f",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe4SCwmbwwIcRi8sknw0mLnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_236f7e9b-01fc-4c47-b362-08c128eec253",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Central High School",
      "poi_type": "Education",
      "poi_address": "3221 Indiana Ave, Kansas City, MO 64128, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a4-9026-758b-a603-ea8657027e1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-9026-758b-a603-ea8657027e1d",
        "storage_key": "property/6767906449167618/019ff6a4-9026-758b-a603-ea8657027e1d.webp",
        "width": 1280,
        "height": 977
      },
      "poi_business_url": "https://www.kcpublicschools.org/central",
      "poi_directions_map_url": "https://maps.google.com/?cid=7694742480629455486&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-high-school",
      "poi_latitude": "39.06676300000001",
      "poi_longitude": "-94.541744",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 816-418-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-91cb1aec8d8f",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5RUJH5TlwIcRftoGhIQ3yWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_a3c979d1-21c7-4162-bde4-57ccdbf292ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "The Nelson-Atkins Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "4525 Oak St, Kansas City, MO 64111, USA",
      "poi_short_description": "Art collection spanning 5,000 years in neoclassical & modern galleries, plus a sculpture garden.",
      "poi_long_description": "Art collection spanning 5,000 years in neoclassical & modern galleries, plus a sculpture garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98b-9929-70c4-98a8-eb4fed6d7fbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98b-9929-70c4-98a8-eb4fed6d7fbf",
        "storage_key": "property/6767906449167618/019fc98b-9929-70c4-98a8-eb4fed6d7fbf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nelson-atkins.org/?utm_source=gmb&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3122843275976164549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-nelson-atkins-museum-of-art",
      "poi_latitude": "39.0449506",
      "poi_longitude": "-94.5809284",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-751-1278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-94d87de7aac3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-94d87de7aac3",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-94d87de7aac3.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJRSCf3ervwIcRxcTG-WmRVis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_7e8d1469-8e59-4674-8880-2c7c899e5d09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Kemper Museum of Contemporary Art",
      "poi_type": "Entertainment",
      "poi_address": "4420 Warwick Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "Modest museum housing a permanent collection & special exhibitions of challenging contemporary art.",
      "poi_long_description": "Modest museum housing a permanent collection & special exhibitions of challenging contemporary art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc994-a852-7706-93db-81452af762af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-a852-7706-93db-81452af762af",
        "storage_key": "property/6767906449167618/019fc994-a852-7706-93db-81452af762af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kemperart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4417124555838519064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kemper-museum-of-contemporary-art",
      "poi_latitude": "39.04643",
      "poi_longitude": "-94.5851292",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-753-5784",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-94d87de7aac3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-94d87de7aac3",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-94d87de7aac3.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjz4brcHvwIcRGPdob2HHTD0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_bc0cbe5f-765f-4c02-ba64-b37032980a20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Loose Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5200 Wornall Rd, Kansas City, MO 64112, USA",
      "poi_short_description": "Site of a Civil War battle, this 75-acre green space features a pond, tennis courts & a rose garden.",
      "poi_long_description": "Site of a Civil War battle, this 75-acre green space features a pond, tennis courts & a rose garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98c-c0d4-756b-8248-2e3c2f99d3e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98c-c0d4-756b-8248-2e3c2f99d3e9",
        "storage_key": "property/6767906449167618/019fc98c-c0d4-756b-8248-2e3c2f99d3e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kcparks.org/park/loose-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11009609457171665569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "loose-park",
      "poi_latitude": "39.0313445",
      "poi_longitude": "-94.5944237",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-2851-753a-b895-67b29d475bf9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-2851-753a-b895-67b29d475bf9",
        "storage_key": "property/6767906449167618/019fc98d-2851-753a-b895-67b29d475bf9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUf-8Na_vwIcRoZJ_Snj9yZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_034c815b-0144-4558-9f77-268563d69cf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Uptown Theater KC",
      "poi_type": "Entertainment",
      "poi_address": "3700 Broadway Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "Classic 1920s film & performing-arts venue, now renovated & hosting concerts & other productions.",
      "poi_long_description": "Classic 1920s film & performing-arts venue, now renovated & hosting concerts & other productions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc993-916d-7052-ab0e-67498a2e4ace.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-916d-7052-ab0e-67498a2e4ace",
        "storage_key": "property/6767906449167618/019fc993-916d-7052-ab0e-67498a2e4ace.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.uptowntheater.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=846736320001238433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uptown-theater-kc",
      "poi_latitude": "39.0611606",
      "poi_longitude": "-94.5907281",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-753-8665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b7d-764b-8edc-5ecad06fe387",
        "storage_key": "property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm94AB9nvwIcRoWUYZDI2wAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wedding_venue"
    },
    {
      "id": "custom_5a018de5-befc-48da-b822-647ddaca1813",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Kauffman Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "1601 Broadway Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "2 performance halls joined together under a glass dome, hosting music, opera, theater & dance.",
      "poi_long_description": "2 performance halls joined together under a glass dome, hosting music, opera, theater & dance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a4-9ef2-7768-a04e-3ae6ae629ef5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-9ef2-7768-a04e-3ae6ae629ef5",
        "storage_key": "property/6767906449167618/019ff6a4-9ef2-7768-a04e-3ae6ae629ef5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kauffmancenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6371724031435486048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kauffman-center-for-the-performing-arts",
      "poi_latitude": "39.0941068",
      "poi_longitude": "-94.5876247",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-994-7222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b7d-764b-8edc-5ecad06fe387",
        "storage_key": "property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99d4bkPwwIcRYDOIbD_pbFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_42938c55-b034-4058-953d-2fd99d77effd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Union Station Kansas City",
      "poi_type": "Entertainment",
      "poi_address": "30 W Pershing Rd, Kansas City, MO 64108, USA",
      "poi_short_description": "Grand, historic train station with permanent & temporary exhibits, a planetarium & a science center.",
      "poi_long_description": "Grand, historic train station with permanent & temporary exhibits, a planetarium & a science center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98b-6f53-7718-b891-2797bf241cc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98b-6f53-7718-b891-2797bf241cc2",
        "storage_key": "property/6767906449167618/019fc98b-6f53-7718-b891-2797bf241cc2.webp",
        "width": 850,
        "height": 1280
      },
      "poi_business_url": "http://www.unionstation.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1677210711716644829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "union-station-kansas-city",
      "poi_latitude": "39.0846332",
      "poi_longitude": "-94.5850238",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-460-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b7d-764b-8edc-621bbb2dc5bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b7d-764b-8edc-621bbb2dc5bf",
        "storage_key": "property/6767906449167618/019fc98d-1b7d-764b-8edc-621bbb2dc5bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxbu2nD_wwIcR3cdZjUGmRhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_09b72f9a-727b-4dbd-938e-621f5725cd71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Screenland Armour Theatre",
      "poi_type": "Entertainment",
      "poi_address": "408 Armour Rd, North Kansas City, MO 64116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66c-2089-707a-a080-eb3af8363eec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-2089-707a-a080-eb3af8363eec",
        "storage_key": "property/6767906449167618/01a0b66c-2089-707a-a080-eb3af8363eec.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.screenland.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16359549647935901976&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "screenland-armour-theatre",
      "poi_latitude": "39.142568",
      "poi_longitude": "-94.575699",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 816-994-7380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66c-3a7e-7094-9d09-923b1f0c606e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0b66c-3a7e-7094-9d09-923b1f0c606e",
        "storage_key": "property/6767906449167618/01a0b66c-3a7e-7094-9d09-923b1f0c606e.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJIYxzebHwwIcRGBGWarrLCOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_4e82c5b6-2b0e-4530-8fde-14e8c41baedf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Folly Theater",
      "poi_type": "Entertainment",
      "poi_address": "300 W 12th St, Kansas City, MO 64105, USA",
      "poi_short_description": "Elegant theater since 1900 showcasing theatrical & musical performances, plus other events.",
      "poi_long_description": "Elegant theater since 1900 showcasing theatrical & musical performances, plus other events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66c-1f73-7038-8404-20c55d02cbe5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-1f73-7038-8404-20c55d02cbe5",
        "storage_key": "property/6767906449167618/01a0b66c-1f73-7038-8404-20c55d02cbe5.webp",
        "width": 1280,
        "height": 830
      },
      "poi_business_url": "http://follytheater.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1659353997130338439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "folly-theater",
      "poi_latitude": "39.100252",
      "poi_longitude": "-94.5872139",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-474-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b7d-764b-8edc-5ecad06fe387",
        "storage_key": "property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNxeXGVzwwIcRhxCUM6s1Bxc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_c87805ea-9e91-42d7-b1b6-3e97d9e157ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Starlight Theatre",
      "poi_type": "Entertainment",
      "poi_address": "4600 Starlight Rd, Kansas City, MO 64132, USA",
      "poi_short_description": "Iconic outdoor theater in Swope Park hosting Broadway shows, rock concerts & other productions.",
      "poi_long_description": "Iconic outdoor theater in Swope Park hosting Broadway shows, rock concerts & other productions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc993-e051-75ce-a194-f56ae595e7b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-e051-75ce-a194-f56ae595e7b7",
        "storage_key": "property/6767906449167618/019fc993-e051-75ce-a194-f56ae595e7b7.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://www.kcstarlight.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12152994064738864795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starlight-theatre",
      "poi_latitude": "39.00745440000001",
      "poi_longitude": "-94.5328221",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 816-363-7827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b7d-764b-8edc-5ecad06fe387",
        "storage_key": "property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_zL1bnlwIcRm84warYbqKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_51025641-e137-4296-9c46-762bd4ef22c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Saint Luke's Hospital of Kansas City",
      "poi_type": "Health and Wellness",
      "poi_address": "4401 Wornall Rd, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc995-0f7d-73e4-b92f-4504122c3931.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-0f7d-73e4-b92f-4504122c3931",
        "storage_key": "property/6767906449167618/019fc995-0f7d-73e4-b92f-4504122c3931.webp",
        "width": 1280,
        "height": 937
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-hospital-kansas-city?utm_source=yext&utm_medium=local_listing&utm_campaign=yext_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4012580085298393479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-hospital-of-kansas-city",
      "poi_latitude": "39.0460972",
      "poi_longitude": "-94.58992940000002",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-932-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b7d-764b-8edc-5bbe0252b6fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b7d-764b-8edc-5bbe0252b6fa",
        "storage_key": "property/6767906449167618/019fc98d-1b7d-764b-8edc-5bbe0252b6fa.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJembMcTvwIcRh3EE-VOMrzc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_89a37829-c341-4bb3-9dc1-efeeee7f39c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "University Health Truman Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2301 Holmes St, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc994-062f-767e-bcce-cd37acb091c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-062f-767e-bcce-cd37acb091c1",
        "storage_key": "property/6767906449167618/019fc994-062f-767e-bcce-cd37acb091c1.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.universityhealthkc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3094198644431175220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-health-truman-medical-center",
      "poi_latitude": "39.0841581",
      "poi_longitude": "-94.5752125",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-404-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b7d-764b-8edc-5bbe0252b6fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b7d-764b-8edc-5bbe0252b6fa",
        "storage_key": "property/6767906449167618/019fc98d-1b7d-764b-8edc-5bbe0252b6fa.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJidv_PG3wwIcRNL7Q-UXN8Co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_08ca1c20-6af0-4f3d-9f4a-0286383a5c11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Saint Luke's Perryman Primary Care-Plaza",
      "poi_type": "Health and Wellness",
      "poi_address": "4321 Washington St ste 3000, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66c-2016-71d6-a12c-8f0a4fbb4ad4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-2016-71d6-a12c-8f0a4fbb4ad4",
        "storage_key": "property/6767906449167618/01a0b66c-2016-71d6-a12c-8f0a4fbb4ad4.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-perryman-primary-care-plaza?utm_source=yext&utm_medium=local_listing&utm_campaign=yext_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4343663036442505921&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-perryman-primary-care-plaza",
      "poi_latitude": "39.0481556",
      "poi_longitude": "-94.5914105",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-932-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b7d-764b-8edc-5ecad06fe387",
        "storage_key": "property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn1CsYs_vwIcRwXIml4TKRzw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_6166d185-6d39-4ff5-80b4-c5492c45c65f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Albers Medical Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4400 Broadway St #106, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a4-a673-76d9-98ed-c6374dc61e19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-a673-76d9-98ed-c6374dc61e19",
        "storage_key": "property/6767906449167618/019ff6a4-a673-76d9-98ed-c6374dc61e19.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.alberspharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2469964368664842582&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "albers-medical-pharmacy",
      "poi_latitude": "39.047298",
      "poi_longitude": "-94.591809",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-931-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a4-b8b4-76da-acbf-70ffb167fd27.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-b8b4-76da-acbf-70ffb167fd27",
        "storage_key": "property/6767906449167618/019ff6a4-b8b4-76da-acbf-70ffb167fd27.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5XUrQsbvwIcRVtEjwoETRyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_788c0323-75cf-4ce5-aaf8-82a893ebd18f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "3845 Broadway Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc994-23e8-732e-acf4-7a0455181fbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-23e8-732e-acf4-7a0455181fbd",
        "storage_key": "property/6767906449167618/019fc994-23e8-732e-acf4-7a0455181fbd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3845+broadway+blvd-kansas+city-mo-64111/id=5278",
      "poi_directions_map_url": "https://maps.google.com/?cid=15848482437788268161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "39.05738789999999",
      "poi_longitude": "-94.5901947",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-561-7620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b7d-764b-8edc-5ecad06fe387",
        "storage_key": "property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVTrIudvvwIcRgfZi7c4e8ds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_bbaf0def-d6d0-4142-9dab-6ac29af24c69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "610 W 48th St, Kansas City, MO 64112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc994-3c0e-716d-82a1-c7c80ff2bf79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-3c0e-716d-82a1-c7c80ff2bf79",
        "storage_key": "property/6767906449167618/019fc994-3c0e-716d-82a1-c7c80ff2bf79.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.clubpilates.com/location/countryclubplaza/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=4052066117731006770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "39.040707",
      "poi_longitude": "-94.5944761",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-875-3226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-91cb1aec8d8f",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN9vdDG_vwIcRMrnAUarUOzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_8c63edde-74a8-485c-a873-2026cab3bb98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Pure Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "515 Nichols Rd, Kansas City, MO 64112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66c-2341-745d-94ca-ffdc611cb5e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-2341-745d-94ca-ffdc611cb5e5",
        "storage_key": "property/6767906449167618/01a0b66c-2341-745d-94ca-ffdc611cb5e5.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.purebarre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6070359749174537015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-barre",
      "poi_latitude": "39.0411412",
      "poi_longitude": "-94.5940268",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-805-2757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b7d-764b-8edc-5ecad06fe387",
        "storage_key": "property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkUNKG-PvwIcRN6tgnAdAPlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_afc73663-7bf0-43e6-8bd2-d1ea2049d10d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "CorePower Yoga - Country Club Plaza",
      "poi_type": "Health and Wellness",
      "poi_address": "4725 Wyandotte St, Kansas City, MO 64112, USA",
      "poi_short_description": "Chain studio offering physically demanding yoga classes in a variety of styles.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc994-68a1-77c8-8a52-914e620a1d29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-68a1-77c8-8a52-914e620a1d29",
        "storage_key": "property/6767906449167618/019fc994-68a1-77c8-8a52-914e620a1d29.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.corepoweryoga.com/yoga-studios/mo/kansas-city/country-club-plaza",
      "poi_directions_map_url": "https://maps.google.com/?cid=14655515030266639755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corepower-yoga---country-club-plaza",
      "poi_latitude": "39.0413974",
      "poi_longitude": "-94.5887442",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 833-448-2561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-91cb1aec8d8f",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx7wA0bjvwIcRi_Vwk0XZYss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_5e93645e-4c5c-4d33-8e1b-2ad7c15f7ac4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Chiefs Fit",
      "poi_type": "Health and Wellness",
      "poi_address": "612 W 47th St, Kansas City, MO 64112, USA",
      "poi_short_description": "Membership-only gym in the Country Club Plaza featuring a sauna, classes, and motivating instructors.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0100a-e246-770b-9081-0e3d8d417e89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-e246-770b-9081-0e3d8d417e89",
        "storage_key": "property/6767906449167618/01a0100a-e246-770b-9081-0e3d8d417e89.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://chiefsfit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12712496314265125622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chiefs-fit",
      "poi_latitude": "39.0426076",
      "poi_longitude": "-94.594501",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 913-914-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b7d-764b-8edc-5ecad06fe387",
        "storage_key": "property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCbLwysnvwIcR9kI8TAvca7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d81c8393-199c-43c8-bd85-f5e4224d3a4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Westport Roanoke KC Parks Community Center",
      "poi_type": "Entertainment",
      "poi_address": "3601 Roanoke Rd, Kansas City, MO 64111, USA",
      "poi_short_description": "Gym and park featuring a basketball court, a playground and tennis courts, plus pottery.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6c3-1752-72ff-afa9-586b0bcafc7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-1752-72ff-afa9-586b0bcafc7e",
        "storage_key": "property/6767906449167618/019ff6c3-1752-72ff-afa9-586b0bcafc7e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://kcparks.org/facility/westport-roanoke-community-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13887253648210499137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westport-roanoke-kc-parks-community-center",
      "poi_latitude": "39.0602953",
      "poi_longitude": "-94.6001195",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-513-7660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b7d-764b-8edc-5ecad06fe387",
        "storage_key": "property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoQ9iW9TvwIcRQZZVf51vucA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "custom_e9859fdf-a269-4baa-9c5d-b1651c69f6ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Gillham Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3915 Gillham Rd, Kansas City, MO 64110, USA",
      "poi_short_description": "Kid-friendly park featuring playgrounds and a splash pad.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc994-efd2-714f-a9b9-47fdde4d2dcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-efd2-714f-a9b9-47fdde4d2dcd",
        "storage_key": "property/6767906449167618/019fc994-efd2-714f-a9b9-47fdde4d2dcd.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://kcparks.org/park/gillham-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4125589893627255631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gillham-park",
      "poi_latitude": "39.0539932",
      "poi_longitude": "-94.5788865",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-2851-753a-b895-67b29d475bf9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-2851-753a-b895-67b29d475bf9",
        "storage_key": "property/6767906449167618/019fc98d-2851-753a-b895-67b29d475bf9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6GFpujvwIcRTxuYYiYKQTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_cfde84d6-5888-4f60-8cd7-45f05d6e3cd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Fountain in Mill Creek Park",
      "poi_type": "Entertainment",
      "poi_address": "47th Mill Creek Pkwy, Kansas City, MO 64111, USA",
      "poi_short_description": "A popular photo op, this illuminated fountain in the city center is surrounded by benches.",
      "poi_long_description": "A popular photo op, this illuminated fountain in the city center is surrounded by benches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a4-b166-76ac-89b5-7d9cdccd5d7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-b166-76ac-89b5-7d9cdccd5d7b",
        "storage_key": "property/6767906449167618/019ff6a4-b166-76ac-89b5-7d9cdccd5d7b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kcparks.org/places/fountain-millcreek/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16120696377665005746&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fountain-in-mill-creek-park",
      "poi_latitude": "39.0426122",
      "poi_longitude": "-94.5875336",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-842-2299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b7d-764b-8edc-5ecad06fe387",
        "storage_key": "property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSaThRb_vwIcRsiimwvE3uN8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fountain"
    },
    {
      "id": "custom_233885e1-fa49-4146-b006-59ded8233da9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Plaza Tennis Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4747 Baltimore Ave, Kansas City, MO 64112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66c-2807-72db-8eae-9323e3e82e5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-2807-72db-8eae-9323e3e82e5f",
        "storage_key": "property/6767906449167618/01a0b66c-2807-72db-8eae-9323e3e82e5f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://kcparks.org/places/plaza-tennis-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10444886900536613402&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plaza-tennis-center",
      "poi_latitude": "39.0414441",
      "poi_longitude": "-94.5878596",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-531-2235",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b7d-764b-8edc-5ecad06fe387",
        "storage_key": "property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeYY5HUXvwIcRGpqd8Uux85A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_club"
    },
    {
      "id": "custom_25d6160e-6965-47cf-8115-031e5de29d0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Penn Valley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "West 29th Street, Broadway Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "Park with the National WWI Museum & Memorial, a theater & tennis, baseball & skateboarding venues.",
      "poi_long_description": "Park with the National WWI Museum & Memorial, a theater & tennis, baseball & skateboarding venues.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a1-09b4-7353-9346-7c471094416c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a1-09b4-7353-9346-7c471094416c",
        "storage_key": "property/6767906449167618/019ff6a1-09b4-7353-9346-7c471094416c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kcparks.org/places/penn-valley-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15561286278733833014&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "penn-valley-park",
      "poi_latitude": "39.0757432",
      "poi_longitude": "-94.588766",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-2851-753a-b895-67b29d475bf9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-2851-753a-b895-67b29d475bf9",
        "storage_key": "property/6767906449167618/019fc98d-2851-753a-b895-67b29d475bf9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYcMmnDvwwIcRNiMXXGzL9Nc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_2305d080-20b9-495f-8141-7165284c11dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Penn Valley Off Leash Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Kansas City, MO 64108, USA",
      "poi_short_description": "Popular fenced park for dogs featuring spacious play areas, water stations and picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66c-2e26-7459-9079-4b26730a3d1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-2e26-7459-9079-4b26730a3d1b",
        "storage_key": "property/6767906449167618/01a0b66c-2e26-7459-9079-4b26730a3d1b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://kcparks.org/places/penn-valley-park-off-leash-dog-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9213271357550555888&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "penn-valley-off-leash-dog-park",
      "poi_latitude": "39.073878",
      "poi_longitude": "-94.5879936",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-2851-753a-b895-67b29d475bf9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-2851-753a-b895-67b29d475bf9",
        "storage_key": "property/6767906449167618/019fc98d-2851-753a-b895-67b29d475bf9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb48XuyTwwIcR8PIUVnwd3H8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_af49c730-5237-4c94-8c8e-919663bb4066",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Frank A. Theis Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4701 Oak St, Kansas City, MO 64110, USA",
      "poi_short_description": "Waterside park for recreation and events, plus a water-lantern festival.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc995-92ba-701d-9bc4-c1c1378f4a19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-92ba-701d-9bc4-c1c1378f4a19",
        "storage_key": "property/6767906449167618/019fc995-92ba-701d-9bc4-c1c1378f4a19.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kcparks.org/places/theis-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3941501393525599333&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frank-a-theis-park",
      "poi_latitude": "39.04099799999999",
      "poi_longitude": "-94.581027",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-2851-753a-b895-67b29d475bf9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-2851-753a-b895-67b29d475bf9",
        "storage_key": "property/6767906449167618/019fc98d-2851-753a-b895-67b29d475bf9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkehMS5TvwIcRZezMaqIGszY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_d56d5c27-202b-41b4-a684-1567b871255f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Southmoreland Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4600 Oak St, Kansas City, MO 64111, USA",
      "poi_short_description": "Lush, shady spot featuring a playground, serene picnic area and an annual Shakespeare festival.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc994-d0f6-74df-b52b-46c54831fe47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-d0f6-74df-b52b-46c54831fe47",
        "storage_key": "property/6767906449167618/019fc994-d0f6-74df-b52b-46c54831fe47.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://kcparks.org/park/southmoreland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12812875925662899750&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southmoreland-park",
      "poi_latitude": "39.04383199999999",
      "poi_longitude": "-94.582651",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-2851-753a-b895-67b29d475bf9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-2851-753a-b895-67b29d475bf9",
        "storage_key": "property/6767906449167618/019fc98d-2851-753a-b895-67b29d475bf9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJC1VAU5XvwIcRJp5K1MR60LE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_b5fa8e37-3abd-4b12-b044-c83488fc53a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Art Museums (45th & Main St)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66c-2923-77a7-8216-891ab002962b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-2923-77a7-8216-891ab002962b",
        "storage_key": "property/6767906449167618/01a0b66c-2923-77a7-8216-891ab002962b.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5601597157677719440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "art-museums-45th--main-st",
      "poi_latitude": "39.045936",
      "poi_longitude": "-94.586609",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a4-b8d1-714c-b329-fc2968666fe7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-b8d1-714c-b329-fc2968666fe7",
        "storage_key": "property/6767906449167618/019ff6a4-b8d1-714c-b329-fc2968666fe7.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJD4-f6MDvwIcRkN83tu_evE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tram_stop"
    },
    {
      "id": "custom_49275fd5-045e-40fa-a62b-6cd336230ed7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "UMKC (51st & Brookside Blvd)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Kansas City, MO 64112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5757662639498616738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "umkc-51st--brookside-blvd",
      "poi_latitude": "39.03583200000001",
      "poi_longitude": "-94.584119",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a4-b8d1-714c-b329-fc2968666fe7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-b8d1-714c-b329-fc2968666fe7",
        "storage_key": "property/6767906449167618/019ff6a4-b8d1-714c-b329-fc2968666fe7.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJS4jvar3vwIcRol_aS6pT508",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tram_stop"
    },
    {
      "id": "custom_7681b64f-98ad-445f-a944-29a2b830f135",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "RideKC - 39th St & Troost Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "3829 Troost Ave, Kansas City, MO 64109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://ridekc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7289192013737135469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ridekc---39th-st--troost-transit-center",
      "poi_latitude": "39.0563082",
      "poi_longitude": "-94.5718268",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-842-9070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b7d-764b-8edc-5ecad06fe387",
        "storage_key": "property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhUypIaHvwIcRbY1qRoRpKGU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_4e680a5e-54e6-4d7a-a34d-74ddbf15c012",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Plaza Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Brookside Blvd, Kansas City, MO 64112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a4-acbc-7132-a6ce-efa519bec9e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-acbc-7132-a6ce-efa519bec9e3",
        "storage_key": "property/6767906449167618/019ff6a4-acbc-7132-a6ce-efa519bec9e3.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16027054283908015915&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plaza-transit-center",
      "poi_latitude": "39.0410459",
      "poi_longitude": "-94.5858921",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b7d-764b-8edc-5ecad06fe387",
        "storage_key": "property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJQvbcADvwIcRK2c9zPSIa94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "custom_50677d25-924c-4409-a5b2-bf2a357a6d75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a4-ae9f-72f5-905e-5d7d9742b2a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-ae9f-72f5-905e-5d7d9742b2a5",
        "storage_key": "property/6767906449167618/019ff6a4-ae9f-72f5-905e-5d7d9742b2a5.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3013901",
      "poi_longitude": "-94.7104232",
      "poi_miles_from_property": "25.4",
      "poi_walking_minutes": "9 hours 29 mins",
      "poi_biking_minutes": "3 hours 2 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-285b-762e-b537-bc7c15801950.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-285b-762e-b537-bc7c15801950",
        "storage_key": "property/6767906449167618/019fc98d-285b-762e-b537-bc7c15801950.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_3c46b79b-b901-441c-84eb-9f366f9cc0af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Stowers Institute for Medical Research",
      "poi_type": "Education",
      "poi_address": "1000 E 50th St, Kansas City, MO 64110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc995-3935-763d-8b2a-71c6f82d818f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-3935-763d-8b2a-71c6f82d818f",
        "storage_key": "property/6767906449167618/019fc995-3935-763d-8b2a-71c6f82d818f.webp",
        "width": 1280,
        "height": 930
      },
      "poi_business_url": "http://www.stowers.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14221194027749611628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stowers-institute-for-medical-research",
      "poi_latitude": "39.0365098",
      "poi_longitude": "-94.5742972",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-926-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b70-737a-9044-91cb1aec8d8f",
        "storage_key": "property/6767906449167618/019fc98d-1b70-737a-9044-91cb1aec8d8f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1aC1p5HvwIcRbBjsAZ_UW8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "research_institute"
    },
    {
      "id": "custom_59944f7e-afd3-468d-bf70-10b3453b37b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Children's Mercy Adele Hall Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "2401 Gillham Rd, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98c-b06b-76ac-a549-b1f45d71e018.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98c-b06b-76ac-a549-b1f45d71e018",
        "storage_key": "property/6767906449167618/019fc98c-b06b-76ac-a549-b1f45d71e018.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.childrensmercy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=241680805565643787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-mercy-adele-hall-campus",
      "poi_latitude": "39.08387889999999",
      "poi_longitude": "-94.5771759",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-234-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b7d-764b-8edc-5bbe0252b6fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b7d-764b-8edc-5bbe0252b6fa",
        "storage_key": "property/6767906449167618/019fc98d-1b7d-764b-8edc-5bbe0252b6fa.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9zZsZRPwwIcRCzzFhGmfWgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_5dd317de-9984-438e-be6c-229ac65abe84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Hallmark Corporate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2501 McGee St, Kansas City, MO 64108, USA",
      "poi_short_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_long_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98c-3180-74b2-b799-97503bd8f344.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98c-3180-74b2-b799-97503bd8f344",
        "storage_key": "property/6767906449167618/019fc98c-3180-74b2-b799-97503bd8f344.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://corporate.hallmark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1199437302719612463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hallmark-corporate",
      "poi_latitude": "39.0811114",
      "poi_longitude": "-94.5800029",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-425-5627",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b7d-764b-8edc-5ecad06fe387",
        "storage_key": "property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjzp5phbwwIcRL4b0Nt9BpRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_fd176490-6590-4710-9227-c4c53c4c16c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Federal Reserve Bank of Kansas City",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Memorial Dr, Kansas City, MO 64198, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019ff6a4-b2f9-7292-914c-4028153fac18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-b2f9-7292-914c-4028153fac18",
        "storage_key": "property/6767906449167618/019ff6a4-b2f9-7292-914c-4028153fac18.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kansascityfed.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17710993233906432888&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "federal-reserve-bank-of-kansas-city",
      "poi_latitude": "39.0753294",
      "poi_longitude": "-94.5858203",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-333-1010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-2850-71af-b060-95dd7f6d3b33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-2850-71af-b060-95dd7f6d3b33",
        "storage_key": "property/6767906449167618/019fc98d-2850-71af-b060-95dd7f6d3b33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa9xf5TzwwIcRePtWZoIWyvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "custom_9396f791-fc0d-479b-b626-c8e1bc8a1c50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "H&R Block",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One H and R, Block Way, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc995-3878-73ea-ba01-80bd344759f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-3878-73ea-ba01-80bd344759f5",
        "storage_key": "property/6767906449167618/019fc995-3878-73ea-ba01-80bd344759f5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hrblock.com/tax-offices/local/missouri-tax-preparation/kansas-city-tax-professionals/?otppartnerid=9308&campaignid=pw_mcm_9308_9762&utm_medium=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17520317420083081084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hr-block",
      "poi_latitude": "39.0982642",
      "poi_longitude": "-94.5829906",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-854-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-1b7d-764b-8edc-5ecad06fe387",
        "storage_key": "property/6767906449167618/019fc98d-1b7d-764b-8edc-5ecad06fe387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB8i63JCKwIcRfO8j8N2rJPM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_a2cac0c6-a9bc-4535-9277-1fe7acef5d2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Jackson County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "415 E 12th St Unit 300, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b66c-3206-760c-a2a2-cd9fb2da25a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66c-3206-760c-a2a2-cd9fb2da25a3",
        "storage_key": "property/6767906449167618/01a0b66c-3206-760c-a2a2-cd9fb2da25a3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.jacksongov.org/Directory.aspx?did=4",
      "poi_directions_map_url": "https://maps.google.com/?cid=1955781323409348683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jackson-county-courthouse",
      "poi_latitude": "39.0992524",
      "poi_longitude": "-94.5781727",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-881-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-2850-71af-b060-95dd7f6d3b33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-2850-71af-b060-95dd7f6d3b33",
        "storage_key": "property/6767906449167618/019fc98d-2850-71af-b060-95dd7f6d3b33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHbRUnWbwwIcRS1goYMBUJBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "custom_a14a7cfc-b9c6-49c2-b5fd-297b352edd2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "custom",
      "poi_name": "Kansas City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Kansas City City Hall, 414 E 12th St, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98c-2d3c-761d-9574-07790d83c6d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98c-2d3c-761d-9574-07790d83c6d3",
        "storage_key": "property/6767906449167618/019fc98c-2d3c-761d-9574-07790d83c6d3.webp",
        "width": 781,
        "height": 1280
      },
      "poi_business_url": "http://www.kcmo.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16264843786418924934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-hall",
      "poi_latitude": "39.1008473",
      "poi_longitude": "-94.5780724",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-513-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/019fc98d-2850-71af-b060-95dd7f6d3b33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98d-2850-71af-b060-95dd7f6d3b33",
        "storage_key": "property/6767906449167618/019fc98d-2850-71af-b060-95dd7f6d3b33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_e-zp2bwwIcRhi24uD9VuOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    }
  ],
  "office_hours": [
    {
      "id": "ec_004249b5996aaf298470acf3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_0b3b34167eb32815dc4e0a2c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_83027a05f2635ebd9fedef19",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_1a3b7ca7860f42f50c95fe38",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_8239f4ded33f42101071da05",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "rating": "5",
      "name": "LInda McLerran",
      "text": "I’m pleased to share how very happy we are as residents at The Dorset. Kary, our manager, goes out of her way for those who  live here, as well as for prospective residents. We held a private party in the event space in the 2nd floor one Saturday, and though it was on a weekend, she responded immediately to some needs that came about in the room. We had resolve right away. She is caring and professional, as is Melissa, a senior manager who also works for the company.  The maintenance people are professional and courteous, as well! The apartments are spacious and new, the other residents are friendly, and it truly is a much more intimate experience than that in many of the larger complexes. We feel like we have friends in the management here, not just business acquaintances!  We heartily recommend!",
      "date": "2021-11-23",
      "title": "false"
    },
    {
      "id": "ec_0d0b5e0487121be6b2d0d6cc",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "rating": "5",
      "name": "V Stew",
      "text": "Great location & small very quiet building. The building managers, Kary & Amy were super to work with & the building maintenance supervisor, Leonard promptly & efficiently addressed small issues. Moving due to family requirements but highly recommend. I’ll miss walking to restaurants, shops, library & grocery.",
      "date": "2022-10-01",
      "title": "false"
    },
    {
      "id": "ec_a0248767e942347f69601d64",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "rating": "5",
      "name": "courtney garcia",
      "text": "My husband, son & I moved here from Chicago sight unseen & I will say the whole process, start to finish, was seamless. The units are beautiful, spacious & the building’s upkeep is very well maintained. Melissa & Kary have been very attentive & accommodating from the get-go for all the things!",
      "date": "2021-11-23",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_895690a947d746a04033f5ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b671-0415-73fc-9f2a-c4118f2899ec.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b671-0415-73fc-9f2a-c4118f2899ec",
        "storage_key": "property/6767906449167618/01a0b671-0415-73fc-9f2a-c4118f2899ec.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Ashmore",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=KAQVBwoo8Cg"
    },
    {
      "id": "ec_004103245dd11761b48fca64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b671-13ea-776d-bb30-c9a0e1f71c20.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b671-13ea-776d-bb30-c9a0e1f71c20",
        "storage_key": "property/6767906449167618/01a0b671-13ea-776d-bb30-c9a0e1f71c20.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Dorchester",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=73YMzSFpNFJ"
    },
    {
      "id": "ec_da05c7422a0f241d9bdbdad5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b671-059d-7409-a34d-b92172963732.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b671-059d-7409-a34d-b92172963732",
        "storage_key": "property/6767906449167618/01a0b671-059d-7409-a34d-b92172963732.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Gillingham",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ACyUxumKdED"
    },
    {
      "id": "ec_20cd81b5c21cc1b124f80275",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b671-03fb-710c-86c3-c8b9558b6067.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b671-03fb-710c-86c3-c8b9558b6067",
        "storage_key": "property/6767906449167618/01a0b671-03fb-710c-86c3-c8b9558b6067.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Portland",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FKnz5iCzoq2"
    },
    {
      "id": "ec_2dd43f50e0f582e9ba46c9be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b671-0621-747e-a9d6-462b788cc23e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b671-0621-747e-a9d6-462b788cc23e",
        "storage_key": "property/6767906449167618/01a0b671-0621-747e-a9d6-462b788cc23e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Verwood",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=VATfwkM6vUd"
    },
    {
      "id": "ec_312e628f32433ea6939ec737",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b671-1e9f-766f-be8a-3e739eed1c54.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b671-1e9f-766f-be8a-3e739eed1c54",
        "storage_key": "property/6767906449167618/01a0b671-1e9f-766f-be8a-3e739eed1c54.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Newton",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=BYdZfjjZYFr"
    },
    {
      "id": "ec_2a58224a21f2f34f7456f2f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b671-3533-7002-b31b-58cdbb00ecf3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b671-3533-7002-b31b-58cdbb00ecf3",
        "storage_key": "property/6767906449167618/01a0b671-3533-7002-b31b-58cdbb00ecf3.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Upton",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=JdFKs6v5LpZ"
    },
    {
      "id": "ec_9a8134ce690a04c69a47773d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "3-bedroom apartment at The Dorset near the Plaza in Kansas City.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b671-2b3e-77ed-829f-777c3c262f8a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b671-2b3e-77ed-829f-777c3c262f8a",
        "storage_key": "property/6767906449167618/01a0b671-2b3e-77ed-829f-777c3c262f8a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Ferndown",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=AmWzSqrt1Pk"
    },
    {
      "id": "ec_e2215f575b49cefa2dc2bd5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167618/01a0b671-2589-73c6-b814-55c7aa657666.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b671-2589-73c6-b814-55c7aa657666",
        "storage_key": "property/6767906449167618/01a0b671-2589-73c6-b814-55c7aa657666.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Colehill",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=rvrok2uXYCh"
    }
  ],
  "faqs": [
    {
      "id": "custom_0d98bbc8-6d3f-4492-ac90-db86e01d4d21",
      "question": "What is the best neighborhood to rent an apartment in Kansas City?",
      "answer": "Kansas City has many distinct neighborhoods to choose from and has something for everyone. Here are some of the best places to live when you're looking for a Kansas City, Missouri apartment for rent:\n• Country Club Plaza / The Plaza - Known as KC’s premier shopping and dining destination, this neighborhood offers Spanish-inspired architecture, fountains, upscale stores, and abundant alfresco restaurants. It’s highly walkable, close to public transit, and offers a luxury urban feel without being quite in the hustle of downtown.\n• Westport - If nightlife, culture, and entertainment are important to you, Westport delivers. Historic and energetic, with live music venues, bars, restaurants, and lots of pedestrian activity, it’s perfect for renters who want to be where things are happening.\n• Midtown - Just outside the core of downtown and the Plaza, Midtown offers a mix of residential and commercial life with more relaxed streets, local coffee shops, boutique businesses, and easy access to the rest of the city. It’s a good balance for those wanting urban conveniences with a bit more calm.\n• River Market / Downtown - For those who want to be right in the center of it all, River Market and Downtown are hard to beat. You’ll be close to big employers, cultural destinations, riverfront parks, markets, and quick access to many parts of Kansas City via transit and major roads.\nIf you’re considering The Dorset in Kansas City Plaza, that places you right in or very near the Country Club Plaza, giving you access to upscale amenities, walkability, and a lifestyle many renters in KC value.",
      "category": "Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_d5a68d9f-061f-4f82-a491-dcad23ed9def",
      "question": "What makes living in Kansas City unique?",
      "answer": "Kansas City offers a vibrant, culturally rich lifestyle with access to world-class dining, local charm, and a strong sense of community. Whether you're looking for walkable neighborhoods, exciting entertainment, or peaceful green spaces, here are some of the unique features and areas to consider:\n• Ideal Location - Living in Kansas City means you're never far from where you need to be. The Dorset places you just off W 46th St and near Highway 56, offering quick access to the Country Club Plaza, Downtown KC, and surrounding districts.\n• Outdoor Adventures - With scenic parks, walking trails, and the iconic Brush Creek nearby, Kansas City offers plenty of ways to enjoy the outdoors. Whether you're biking along the Trolley Track Trail or exploring Loose Park, nature is always within reach.\n• Premium Living - Areas like the Country Club Plaza blend historic charm with upscale living, think designer shopping, gourmet dining, and elegant architecture. The Dorset’s refined interiors and modern amenities fit seamlessly into this elevated lifestyle.\n• Local Community - Kansas City’s unique blend of Midwestern hospitality and cultural sophistication creates a welcoming, down-to-earth environment. From local art galleries and farmers markets to live jazz venues and neighborhood festivals, there’s always something to discover.",
      "category": "Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_0bbba874-171c-40c5-a9b2-7feca2129c65",
      "question": "What are some things to do in Kansas City?",
      "answer": "There are many fun activities to do in Kansas City! The Dorset's prime Plaza location puts residents in the heart of one of the city’s most walkable and culturally vibrant neighborhoods. Major attractions and activities in the area include:\n• Country Club Plaza\n• Loose Park\n• The Nelson-Atkins Museum of Art\n• Union Station\n• Kemper Museum of Contemporary Art\n• Westport Entertainment District\n• Brush Creek Walking Trail\n• 47th Street Dining and Shopping",
      "category": "Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_2d8e8ac1-de56-4df7-8c67-cb569eebfc73",
      "question": "How close is Kansas City Plaza to major employers in Kansas City?",
      "answer": "The Dorset in Kansas City is only minutes from the area’s top employers. The proximity to Highway 56, I-35, and Main Street gives easy access to healthcare, corporate, education, and tech employers, like:\n• Saint Luke’s Health System\n• Cerner / Oracle Cerner\n• Hallmark Cards\n• Burns & McDonnell\n• Children’s Mercy\n• UMB Financial Corporation\n• Honeywell (Federal Manufacturing / Technology)\n• Ford Motor Company (Kansas City Assembly)",
      "category": "Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_2126d829-22e1-4265-9026-20abb9605b8a",
      "question": "What are the best apartment amenities in Kansas City?",
      "answer": "At The Dorset, you'll find a variety of amenities that make living in vibrant Kansas City even better, such as:\n• Rooftop Deck with Plaza Views - Unwind above the city with scenic views of the Country Club Plaza, perfect for relaxing evenings, outdoor socializing, or simply enjoying the Kansas City skyline after a day of exploring.\n• Fully Equipped Fitness Center - Stay on top of your wellness goals without leaving home. Whether you're training for a local 5K or just staying active, the on-site gym makes it easy to fit workouts into your lifestyle.\n• Pet-Friendly Perks with Washing Station - Pet owners will appreciate thoughtful touches like the on-site pet washing station, ideal for cleaning up after walks around nearby Loose Park or the Brush Creek trails.\n• Stylish, Functional Interiors - With high ceilings, hardwood floors, and built-in desks in select layouts, your apartment is designed for both comfort and productivity, whether you're working from home or hosting friends for dinner.",
      "category": "Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_611b7d77-8880-4a7c-8616-657fdd2ade9a",
      "question": "Is parking available?",
      "answer": "Yes, we offer a covered parking garage.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_8eae7485-aebb-4565-aa4f-57d668719f0d",
      "question": "What amenities does the property offer?",
      "answer": "The Dorset offers a parking garage, elevator, fitness center, pet wash station, rooftop deck, guest suite, washer and dryer, granite countertops, and stainless steel appliances.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_3fb0dd61-62e8-4362-b6a9-d0494234541c",
      "question": "Is your community pet friendly?",
      "answer": "Yes! Please see more information on our <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_d988c092-dd9f-4671-8b0d-c88d4c7f80f2",
      "question": "What appliances are standard?",
      "answer": "Standard appliances include a refrigerator, stove/oven, microwave, dishwasher, and washer and dryer.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_21d56d8e-d8dc-40db-b158-029e66b378a3",
      "question": "Do you offer furnished apartments?",
      "answer": "We do not offer furnished apartments at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_50907f7d-18d9-4480-b97e-522ee30585a8",
      "question": "How long does it take for an application to be approved?",
      "answer": "Applications are approved within 72 hours.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_008cea7c-ea16-4a8f-abe0-b640863c0ed0",
      "question": "What are my options for paying my rent?",
      "answer": "Rent can be paid <a href=\"/resident-access\">online</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_66e37526-1761-4195-bd49-d0568fbd9524",
      "question": "Am I required to purchase renter's insurance?",
      "answer": "Yes, renter's insurance is required.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_bfdc51ce-7fdf-44a0-8fe8-219232ff2ffd",
      "question": "Which provider can I use for Internet and cable?",
      "answer": "AT&T is the provider for internet and cable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_c191001e-bc6b-4196-8fc1-89262b802712",
      "question": "If my situation changes can I get out of my lease?",
      "answer": "There is a requirement of a 60 day notice and a buy-out fee of one month’s rent.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_c8dbc7bc-8ef5-4ee6-a70d-9db4da9f2376",
      "question": "How do I set up my utilities?",
      "answer": "Set up electricity with Evergy and cable/internet with AT&T.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_55823425-c230-443a-883e-a959bdda958f",
      "question": "Which utilities are included in my rent?",
      "answer": "No utilities are included in rent.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_923215da-fbc8-404b-adc5-31c3adb801c8",
      "question": "What will you do to prepare my apartment before I move in?",
      "answer": "Painting, cleaning, and maintenance completion of the apartment is done prior to move in.",
      "category": "Maintenance",
      "source": "custom"
    },
    {
      "id": "custom_fbf89d2c-0fd5-4eab-a4f1-1918cee2afba",
      "question": "Do I have to be present for a service technician to perform work?",
      "answer": "No, you do not need to be present for a service technician to perform work.",
      "category": "Maintenance",
      "source": "custom"
    },
    {
      "id": "custom_62e72e5c-10b3-4078-a344-0be4dfd7c3a0",
      "question": "Do you have on-site maintenance?",
      "answer": "Yes, we have on-site maintenance.",
      "category": "Maintenance",
      "source": "custom"
    },
    {
      "id": "custom_6ce823ef-d973-4083-9940-cfdca1d7ab3f",
      "question": "An item in my unit needs repair. How do I get help?",
      "answer": "Please submit a maintenance request on the <a href=\"/resident-access\">portal</a>.",
      "category": "Maintenance",
      "source": "custom"
    },
    {
      "id": "custom_b8e7f46f-0895-42ad-a9b3-ea1c6534e8b5",
      "question": "What happens if I am locked out?",
      "answer": "Call emergency maintenance at <span data-type=\"field-token\" data-field=\"property_call_tracking_phone\"></span>.",
      "category": "Maintenance",
      "source": "custom"
    },
    {
      "id": "custom_1928908e-c4be-46d2-95e9-4f8a64283da0",
      "question": "Is there public transportation within close proximity of the buildings?",
      "answer": "Yes, streetcars are within close proximity.",
      "category": "Location",
      "source": "custom"
    },
    {
      "id": "custom_30f0deee-5cc5-4e0a-a349-4a26efa898e6",
      "question": "Which school district are you in?",
      "answer": "The Dorset is in the Kansas City 33 School District.",
      "category": "Location",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-4d04-76b8-b862-ae1d43f87974",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Dorset Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618"
    },
    {
      "lead_collector_id": "01a0c9ac-4d8c-768d-89e6-2b2aa3a103a0",
      "lead_source": "LANDING_PAGE",
      "name": "The Dorset Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "generator",
      "page_item_url": "dorset-apartments-in-unit-laundry-kansas-city-mo",
      "search_query": "apartments with in-unit laundry Kansas City MO",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Kansas City, MO",
      "h2_subtitle": "Discover The Dorset's stylish apartments with in-unit laundry located in Kansas City, MO. Experience the convenience and modern living in Midtown - Westport.",
      "page_copy": "The Dorset offers premium apartments with in-unit laundry in Kansas City, MO, combining convenience and style. Nestled in the vibrant Midtown - Westport area, our one-, two-, and three-bedroom homes deliver elevated finishes perfect for the modern dweller. With amenities like air conditioning and wheelchair access, living in Kansas City has never been more comfortable or accessible. \n\nExperience connected living at The Dorset, where you're a short walk away from the lively Westport scene and the refined Plaza district. Take advantage of convenient package services and a study area designed for getting work done. St. Luke's Hospital is also nearby, adding an extra layer of convenience. Explore our floor plans today and see firsthand what makes The Dorset the ideal choice for apartments with in-unit laundry in Kansas City, MO.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
      "featured_image_media": {
        "alt_text": "Rooftop deck with seating and dining areas overlooking trees and cityscape.",
        "public_id": "019fc98c-46fe-75d9-88b0-660d469e7f49",
        "storage_key": "property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments, Kansas City, MO | The Dorset",
      "seo_description": "Explore The Dorset's Kansas City, MO apartments with in-unit laundry. Enjoy modern living in Midtown - Westport, with in-unit laundry and amazing amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "generator",
      "page_item_url": "dorset-air-conditioned-apartments-midtown-westport",
      "search_query": "air conditioned apartments in Midtown Westport",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Midtown Westport",
      "h2_subtitle": "Stay cool at The Dorset, where air conditioned apartments offer comfort and style in the bustling Midtown Westport community of Kansas City.",
      "page_copy": "The Dorset provides air conditioned apartments in the vibrant neighborhood of Midtown Westport, Kansas City. Our one-, two-, and three-bedroom homes feature elevated finishes designed for modern living. Enjoy the perfect blend of Plaza polish and Westport energy with spacious floor plans and contemporary amenities.\n\nAs a resident of The Dorset, you'll appreciate the package service and dedicated study areas. Wheelchair access and proximity to St. Luke's Hospital add convenience to your daily life. The Midtown Westport area offers an exciting mix of culture, dining, and entertainment, all within easy reach. Discover your ideal home at The Dorset and enjoy the comfort of air conditioned living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
      "featured_image_media": {
        "alt_text": "Rooftop deck with seating and dining areas overlooking trees and cityscape.",
        "public_id": "019fc98c-46fe-75d9-88b0-660d469e7f49",
        "storage_key": "property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Midtown Westport | The Dorset",
      "seo_description": "Find your air conditioned apartment at The Dorset in Midtown Westport. Enjoy modern comfort and amenities in Kansas City's lively neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "generator",
      "page_item_url": "dorset-gated-community-apartments-near-st-lukes-hospital",
      "search_query": "gated community apartments near St. Luke's Hospital",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments Near St. Luke’s Hospital",
      "h2_subtitle": "Discover luxury living in a gated community near St. Luke’s Hospital at The Dorset. Experience convenience and comfort in Kansas City, MO.",
      "page_copy": "At The Dorset, enjoy living in a gated community apartment near St. Luke’s Hospital, offering both convenience and security. Our spacious one-, two-, and three-bedroom homes boast elevated finishes, providing a refined living experience. Nestled in the heart of Midtown - Westport, The Dorset delivers the perfect blend of style, comfort, and accessibility.\n\nOur residents benefit from convenient amenities such as package service, a study area, and wheelchair access. The community's prime location ensures you're just steps away from vibrant Westport attractions while enjoying the peace of mind that comes with living near St. Luke’s Hospital. Explore our floor plans today and see why The Dorset is the ideal choice for gated community apartments in Kansas City, MO.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
      "featured_image_media": {
        "alt_text": "Rooftop deck with seating and dining areas overlooking trees and cityscape.",
        "public_id": "019fc98c-46fe-75d9-88b0-660d469e7f49",
        "storage_key": "property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apts Near St. Luke’s Hospital | The Dorset",
      "seo_description": "Live in a gated community near St. Luke’s Hospital at The Dorset. Enjoy spacious, stylish apartments with premium amenities in Kansas City, MO.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "generator",
      "page_item_url": "dorset-rooftop-deck-apartments-jackson-county",
      "search_query": "rooftop deck apartments Jackson County",
      "category": "Amenity",
      "h1_title": "Rooftop Deck Apartments in Jackson County",
      "h2_subtitle": "Experience The Dorset's rooftop deck apartments in Jackson County. Enjoy breathtaking views and modern living in Kansas City's Midtown - Westport area.",
      "page_copy": "The Dorset invites you to discover rooftop deck apartments in Jackson County, where modern amenities meet stylish living. Our spacious one-, two-, and three-bedroom residences combine elevated finishes with the vibrant lifestyle of Midtown - Westport, Kansas City.\n\nCatch stunning views and relax on our rooftop deck, a perfect complement to your busy lifestyle. Residents also appreciate amenities like air conditioning, package services, and wheelchair access, enhancing the convenience of modern living. With the community's proximity to St. Luke's Hospital, you'll find both comfort and accessibility are just steps away. Make The Dorset your new home and enjoy a unique living experience in Jackson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
      "featured_image_media": {
        "alt_text": "Rooftop deck with seating and dining areas overlooking trees and cityscape.",
        "public_id": "019fc98c-46fe-75d9-88b0-660d469e7f49",
        "storage_key": "property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rooftop Deck Apartments Jackson County | The Dorset",
      "seo_description": "Discover rooftop deck apartments at The Dorset in Jackson County. Experience stylish living with modern amenities in Kansas City's Midtown - Westport.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "generator",
      "page_item_url": "dorset-fitness-center-apartments-kansas-city-64112",
      "search_query": "fitness center apartments Kansas City 64112",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Kansas City 64112",
      "h2_subtitle": "Stay active at The Dorset's fitness center apartments, centrally located in Kansas City 64112. Enjoy modern amenities and a vibrant community.",
      "page_copy": "Discover fitness center apartments at The Dorset, uniquely positioned in the heart of Kansas City 64112. Our community offers spacious one-, two-, and three-bedroom homes with refined finishes, perfect for those seeking a balanced lifestyle. With the energy of Midtown - Westport all around, you'll find staying active effortless.\n\nResidents benefit from a variety of amenities, including a fitness center, air conditioning, and convenient package services. The Dorset's proximity to local attractions and St. Luke's Hospital ensures easy access to everything you need. Explore our floor plans and join a community that prioritizes health and modern living in Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
      "featured_image_media": {
        "alt_text": "Rooftop deck with seating and dining areas overlooking trees and cityscape.",
        "public_id": "019fc98c-46fe-75d9-88b0-660d469e7f49",
        "storage_key": "property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments Kansas City 64112 | The Dorset",
      "seo_description": "Live in fitness center apartments at The Dorset, Kansas City 64112. Enjoy modern amenities and a vibrant community in the heart of Midtown - Westport.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "generator",
      "page_item_url": "dorset-1-bedroom-apartments-midtown-kansas-city",
      "search_query": "1 bedroom apartments midtown kansas city",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Midtown Kansas City",
      "h2_subtitle": "Explore The Dorset's 1 bedroom apartments in Midtown Kansas City. Experience stylish living with modern amenities in a vibrant neighborhood.",
      "page_copy": "Welcome to The Dorset, where our 1 bedroom apartments in Midtown Kansas City offer a perfect blend of style and convenience. Located in the bustling area of Midtown - Westport, our homes feature elevated finishes designed for modern living. Whether you're downsizing or seeking a new home, our one-bedroom units provide the comfort and functionality you desire.\n\nAt The Dorset, enjoy amenities such as air conditioning, package service, and an accessible community environment. With quick access to local hotspots and the nearby St. Luke's Hospital, you’ll find everything you need right at your doorstep. Discover the effortless charm and convenience of living in our 1 bedroom apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
      "featured_image_media": {
        "alt_text": "Rooftop deck with seating and dining areas overlooking trees and cityscape.",
        "public_id": "019fc98c-46fe-75d9-88b0-660d469e7f49",
        "storage_key": "property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments Midtown Kansas City | The Dorset",
      "seo_description": "Find stylish 1 bedroom apartments at The Dorset in Midtown Kansas City. Enjoy modern amenities in the lively Midtown - Westport area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "generator",
      "page_item_url": "dorset-2-bedroom-apartments-jackson-county",
      "search_query": "2 bedroom apartments jackson county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Jackson County",
      "h2_subtitle": "Discover The Dorset's spacious 2 bedroom apartments in Jackson County. Enjoy modern living with exceptional amenities in a lively community.",
      "page_copy": "The Dorset offers exceptional 2 bedroom apartments in Jackson County, blending modern style with practical living. Located in the heart of Midtown - Westport, Kansas City, our two-bedroom homes provide ample space with elevated finishes to suit any lifestyle.\n\nResidents at The Dorset enjoy an array of amenities such as air conditioning, package service, and wheelchair access, all designed to enhance daily living. Plus, our proximity to local attractions, including St. Luke's Hospital, ensures everything you need is within easy reach. Experience the best of Jackson County living in our thoughtfully designed community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
      "featured_image_media": {
        "alt_text": "Rooftop deck with seating and dining areas overlooking trees and cityscape.",
        "public_id": "019fc98c-46fe-75d9-88b0-660d469e7f49",
        "storage_key": "property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Jackson County | The Dorset",
      "seo_description": "Spacious 2 bedroom apartments await at The Dorset in Jackson County. Enjoy modern amenities and the convenience of Midtown - Westport living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "generator",
      "page_item_url": "dorset-3-bedroom-apartments-near-westport-mo",
      "search_query": "3 bedroom apartments near westport mo",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near Westport, MO",
      "h2_subtitle": "Experience The Dorset's spacious 3 bedroom apartments near Westport, MO. Modern amenities in a vibrant community await you.",
      "page_copy": "Discover the spacious comfort of The Dorset's 3 bedroom apartments near Westport, MO, where Plaza polish meets Westport energy. Perfect for families or roommates, our three-bedroom homes feature elevated finishes, ensuring a stylish, sophisticated living environment.\n\nLocated in Midtown, just a stone's throw from Westport, our community offers amenities such as air conditioning and convenient package services. The Dorset places you close to local attractions and essential services like St. Luke's Hospital, making it an ideal choice for those seeking comfort and convenience in a bustling neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
      "featured_image_media": {
        "alt_text": "Rooftop deck with seating and dining areas overlooking trees and cityscape.",
        "public_id": "019fc98c-46fe-75d9-88b0-660d469e7f49",
        "storage_key": "property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near Westport, MO | The Dorset",
      "seo_description": "Spacious 3 bedroom apartments at The Dorset near Westport, MO. Enjoy modern amenities in a lively community next to Midtown - Westport.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "generator",
      "page_item_url": "dorset-apartments-near-university-of-missouri-kansas-city",
      "search_query": "apartments near university of missouri kansas city",
      "category": "School",
      "h1_title": "Apartments Near University of Missouri Kansas City",
      "h2_subtitle": "Discover The Dorset's ideal location near the University of Missouri Kansas City. Enjoy convenience and modern amenities in Midtown - Westport.",
      "page_copy": "The Dorset provides an unbeatable living experience with its apartments near the University of Missouri Kansas City. Perfectly situated in the vibrant Midtown - Westport area, our community offers quick access to the university, making it an excellent choice for students, faculty, and staff alike.\n\nOur apartments boast modern amenities such as air conditioning, package service, and wheelchair access, enhancing your daily living experience. Enjoy a dynamic lifestyle with the convenience of being close to the university, while also having local hotspots and essential services like St. Luke's Hospital nearby. Come and explore our inviting community today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
      "featured_image_media": {
        "alt_text": "Rooftop deck with seating and dining areas overlooking trees and cityscape.",
        "public_id": "019fc98c-46fe-75d9-88b0-660d469e7f49",
        "storage_key": "property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Missouri Kansas City",
      "seo_description": "Find convenient living at The Dorset, near the University of Missouri Kansas City. Enjoy modern amenities in vibrant Midtown - Westport.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "generator",
      "page_item_url": "dorset-apartments-close-to-kansas-city-art-institute",
      "search_query": "apartments close to kansas city art institute midtown westport",
      "category": "School",
      "h1_title": "Apartments Close to Kansas City Art Institute",
      "h2_subtitle": "The Dorset offers stylish apartments close to Kansas City Art Institute in Midtown - Westport. Enjoy convenience and vibrant city living.",
      "page_copy": "Situated in the heart of Kansas City's cultural scene, The Dorset provides stylish apartments close to the Kansas City Art Institute in Midtown - Westport. Ideal for students and art enthusiasts, our community offers convenient access to this renowned institution while maintaining a vibrant living environment.\n\nOur one-, two-, and three-bedroom homes feature elevated finishes and modern conveniences like air conditioning and package service. The Dorset enhances your lifestyle with amenities designed for comfort and ease, including wheelchair access. Experience the thrill of city living with art and culture just steps away, while also being near other local attractions such as St. Luke's Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
      "featured_image_media": {
        "alt_text": "Rooftop deck with seating and dining areas overlooking trees and cityscape.",
        "public_id": "019fc98c-46fe-75d9-88b0-660d469e7f49",
        "storage_key": "property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Kansas City Art Institute",
      "seo_description": "Explore The Dorset's convenient living near the Kansas City Art Institute in Midtown - Westport. Modern amenities and vibrant surroundings await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "generator",
      "page_item_url": "dorset-apartments-by-rockhurst-university-kcmo",
      "search_query": "apartments by rockhurst university kcmo",
      "category": "School",
      "h1_title": "Apartments by Rockhurst University, KCMO",
      "h2_subtitle": "Explore The Dorset's apartments by Rockhurst University, KCMO. Enjoy modern amenities and connected living in Midtown - Westport.",
      "page_copy": "The Dorset offers the perfect location with apartments by Rockhurst University, KCMO. Our community is located in the vibrant Midtown - Westport area, making it an ideal choice for students, faculty, and staff seeking comfortable living close to campus.\n\nOur apartments feature spacious one-, two-, and three-bedroom layouts with modern finishes and essential amenities like air conditioning and package service. With wheelchair access and proximity to essential services such as St. Luke's Hospital, The Dorset combines convenience with vibrant city living. Enjoy the blend of comfort, convenience, and culture living near Rockhurst University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
      "featured_image_media": {
        "alt_text": "Rooftop deck with seating and dining areas overlooking trees and cityscape.",
        "public_id": "019fc98c-46fe-75d9-88b0-660d469e7f49",
        "storage_key": "property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Rockhurst University, KCMO",
      "seo_description": "Discover The Dorset's ideal location near Rockhurst University, KCMO. Spacious homes with modern amenities in Midtown - Westport.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "generator",
      "page_item_url": "dorset-midtown-apartments-near-st-pauls-episcopal-day",
      "search_query": "midtown apartments near st pauls episcopal day school",
      "category": "School",
      "h1_title": "Midtown Apartments Near St. Paul's Episcopal Day",
      "h2_subtitle": "Find The Dorset's midtown apartments near St. Paul's Episcopal Day School. Experience comfortable living in a vibrant community.",
      "page_copy": "Located in the bustling Midtown - Westport area, The Dorset offers ideal midtown apartments near St. Paul's Episcopal Day School. Our community provides easy access to reputable schools, making it a convenient choice for families seeking quality education opportunities nearby.\n\nThe Dorset features one-, two-, and three-bedroom apartments with modern finishes and amenities such as air conditioning, package service, and wheelchair access. Residents can enjoy a connected lifestyle close to shopping, dining, and medical facilities like St. Luke's Hospital, making our community an excellent choice for those seeking both comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
      "featured_image_media": {
        "alt_text": "Rooftop deck with seating and dining areas overlooking trees and cityscape.",
        "public_id": "019fc98c-46fe-75d9-88b0-660d469e7f49",
        "storage_key": "property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Midtown Apartments Near St. Paul's Episcopal Day",
      "seo_description": "Discover The Dorset's midtown living near St. Paul's Episcopal Day School. Enjoy modern amenities and vibrant surroundings in Midtown - Westport.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "generator",
      "page_item_url": "dorset-apartments-midtown-near-st-teresas-academy",
      "search_query": "apartments in midtown near st teresas academy",
      "category": "School",
      "h1_title": "Apartments in Midtown Near St. Teresa's Academy",
      "h2_subtitle": "Discover The Dorset's apartments in midtown near St. Teresa's Academy. Enjoy modern living in a dynamic neighborhood.",
      "page_copy": "Positioned perfectly in Midtown - Westport, The Dorset offers charming apartments in midtown near St. Teresa's Academy. An ideal spot for families and educators, our community provides the convenience of being close to top-tier educational institutions.\n\nResidents at The Dorset can choose from spacious one-, two-, and three-bedroom homes, each thoughtfully designed with modern finishes. Amenities such as package service, air conditioning, and wheelchair access ensure a comfortable living experience. Enjoy a vibrant urban lifestyle with local attractions and essential services including the nearby St. Luke's Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
      "featured_image_media": {
        "alt_text": "Rooftop deck with seating and dining areas overlooking trees and cityscape.",
        "public_id": "019fc98c-46fe-75d9-88b0-660d469e7f49",
        "storage_key": "property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments in Midtown Near St. Teresa's Academy",
      "seo_description": "Find The Dorset's prime location near St. Teresa's Academy. Modern Midtown living with top amenities awaits you in Westport.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "generator",
      "page_item_url": "dorset-jackson-county-apartments-near-rockhurst-high",
      "search_query": "jackson county apartments close to rockhurst high school",
      "category": "School",
      "h1_title": "Jackson County Apartments Near Rockhurst High School",
      "h2_subtitle": "Explore Jackson County apartments near Rockhurst High School at The Dorset. Enjoy comfortable living with modern amenities.",
      "page_copy": "The Dorset offers exceptional Jackson County apartments near Rockhurst High School, located in the lively Midtown - Westport area. Perfect for families, faculty, and students, our community provides easy access to education, culture, and entertainment.\n\nOur one-, two-, and three-bedroom apartments feature contemporary finishes and essential amenities like air conditioning and package service. The Dorset also offers wheelchair access and is conveniently situated near medical facilities such as St. Luke's Hospital, ensuring residents can enjoy a balanced urban lifestyle with modern comforts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
      "featured_image_media": {
        "alt_text": "Rooftop deck with seating and dining areas overlooking trees and cityscape.",
        "public_id": "019fc98c-46fe-75d9-88b0-660d469e7f49",
        "storage_key": "property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Jackson County Apartments Near Rockhurst High School",
      "seo_description": "Discover The Dorset's proximity to Rockhurst High School. Experience modern living and amenities in Jackson County's Midtown - Westport.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "generator",
      "page_item_url": "dorset-apartments-near-primitivo-garcia-elementary-kc",
      "search_query": "apartments near primitivo garcia elementary school kc",
      "category": "School",
      "h1_title": "Apartments Near Primitivo Garcia Elementary KC",
      "h2_subtitle": "Discover The Dorset's apartments near Primitivo Garcia Elementary in KC. Enjoy convenient living in a vibrant community.",
      "page_copy": "Nestled in the energetic Midtown - Westport area, The Dorset features spacious apartments near Primitivo Garcia Elementary School KC. Ideal for families and professionals, our community combines modern amenities with a convenient location.\n\nResidents can choose from stylish one-, two-, or three-bedroom homes boasting premium finishes. Enjoy amenities like air conditioning, package service, and wheelchair access. With proximity to educational centers and St. Luke's Hospital, The Dorset ensures a vibrant, well-connected lifestyle in Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
      "featured_image_media": {
        "alt_text": "Rooftop deck with seating and dining areas overlooking trees and cityscape.",
        "public_id": "019fc98c-46fe-75d9-88b0-660d469e7f49",
        "storage_key": "property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Primitivo Garcia Elementary KC",
      "seo_description": "Find The Dorset's prime apartments near Primitivo Garcia Elementary. Experience modern living in the heart of Kansas City's Midtown - Westport.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "generator",
      "page_item_url": "dorset-midtown-westport-apartments-central-middle-school",
      "search_query": "midtown westport apartments by central middle school",
      "category": "School",
      "h1_title": "Midtown Westport Apartments by Central Middle School",
      "h2_subtitle": "Find The Dorset's apartments by Central Middle School in Midtown Westport. Enjoy a vibrant life with modern amenities.",
      "page_copy": "Located in the energetic Midtown - Westport area, The Dorset offers premium apartments by Central Middle School. This prime location is perfect for those seeking convenience and community engagement.\n\nOur one-, two-, and three-bedroom residences are designed with upscale finishes, catering to a contemporary lifestyle. Residents benefit from amenities such as air conditioning, package services, and wheelchair accessibility. With Central Middle School nearby and close proximity to St. Luke's Hospital, The Dorset provides a balanced and fulfilling living experience in Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
      "featured_image_media": {
        "alt_text": "Rooftop deck with seating and dining areas overlooking trees and cityscape.",
        "public_id": "019fc98c-46fe-75d9-88b0-660d469e7f49",
        "storage_key": "property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Midtown Westport Apartments by Central Middle School",
      "seo_description": "Discover The Dorset's location by Central Middle School. Enjoy modern living and amenities in Midtown Westport.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "generator",
      "page_item_url": "dorset-westport-kc-apartments-near-central-high-school",
      "search_query": "westport kc apartments near central high school",
      "category": "School",
      "h1_title": "Westport KC Apartments Near Central High School",
      "h2_subtitle": "Explore The Dorset's Westport KC apartments near Central High School. Embrace urban living in a thriving community.",
      "page_copy": "The Dorset offers an exceptional living experience in Westport KC with its well-appointed apartments near Central High School. Perfect for students, educators, and families, our community offers convenient access to educational and cultural hubs.\n\nChoose from our spacious one-, two-, and three-bedroom apartments, each featuring high-end finishes and essential amenities like air conditioning and package service. The Dorset's strategic location also provides easy access to healthcare facilities such as St. Luke's Hospital, ensuring a seamless blend of comfort and connectivity in the heart of Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
      "featured_image_media": {
        "alt_text": "Rooftop deck with seating and dining areas overlooking trees and cityscape.",
        "public_id": "019fc98c-46fe-75d9-88b0-660d469e7f49",
        "storage_key": "property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Westport KC Apartments Near Central High School",
      "seo_description": "Find your ideal home at The Dorset, close to Central High School. Enjoy modern amenities in Westport KC's vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "generator",
      "page_item_url": "dorset-apartments-near-university-health-truman-medical-center",
      "search_query": "apartments near university health truman medical center kansas city",
      "category": "Hospital",
      "h1_title": "Apartments Near University Health Truman KC",
      "h2_subtitle": "Stay close to medical facilities with The Dorset's apartments near University Health Truman Medical Center in Kansas City.",
      "page_copy": "If you're seeking proximity to healthcare facilities, The Dorset offers exceptional apartments near University Health Truman Medical Center in Kansas City. Ideal for medical professionals and families, our community is thoughtfully located in the dynamic Midtown - Westport area.\n\nOur elegant one-, two-, and three-bedroom homes are adorned with upscale features and provide amenities like air conditioning and package service. Enjoy the convenience of being near major healthcare and education establishments, ensuring a harmonious blend of professional and personal life in Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
      "featured_image_media": {
        "alt_text": "Rooftop deck with seating and dining areas overlooking trees and cityscape.",
        "public_id": "019fc98c-46fe-75d9-88b0-660d469e7f49",
        "storage_key": "property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University Health Truman KC",
      "seo_description": "Discover The Dorset's convenient location near University Health Truman Medical Center. Enjoy modern living in Kansas City's Midtown - Westport.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "generator",
      "page_item_url": "dorset-apartments-near-childrens-mercy-adele-hall-campus",
      "search_query": "apartments close to children's mercy adele hall campus midtown westport",
      "category": "Hospital",
      "h1_title": "Apartments Near Children's Mercy Adele Hall",
      "h2_subtitle": "Live near Children's Mercy Adele Hall Campus at The Dorset, offering premium Midtown Westport apartments.",
      "page_copy": "The Dorset presents an ideal residence for those seeking apartments close to Children's Mercy Adele Hall Campus in Midtown Westport. This location is perfect for healthcare workers, families, and anyone valuing proximity to top-tier medical care.\n\nOur spacious one-, two-, and three-bedroom apartments are equipped with luxury finishes and essential amenities like air conditioning and package service. Embrace the benefits of living in a vibrant neighborhood with easy access to medical facilities and community resources, all while enjoying the community atmosphere here in Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
      "featured_image_media": {
        "alt_text": "Rooftop deck with seating and dining areas overlooking trees and cityscape.",
        "public_id": "019fc98c-46fe-75d9-88b0-660d469e7f49",
        "storage_key": "property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Children's Mercy Adele Hall",
      "seo_description": "Find your next home at The Dorset, near Children's Mercy Adele Hall Campus. Experience modern living in Midtown Westport.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "generator",
      "page_item_url": "dorset-apartments-near-penn-valley-dog-park-kc",
      "search_query": "apartments near Penn Valley Off Leash Dog Park Kansas City",
      "category": "Park",
      "h1_title": "Apartments Near Penn Valley Dog Park KC",
      "h2_subtitle": "Discover pet-friendly living at The Dorset, with apartments near Penn Valley Off Leash Dog Park in Kansas City.",
      "page_copy": "If you're looking for a pet-friendly community, consider The Dorset, offering excellent apartments near Penn Valley Off Leash Dog Park in Kansas City. It's the perfect place for dog lovers who want easy access to recreational spaces for their furry friends.\n\nOur one-, two-, and three-bedroom homes come with stylish finishes and essential amenities like air conditioning and wheelchair access. Located in the bustling Midtown - Westport area, The Dorset combines urban living with outdoor opportunities, making it the ideal home for both you and your pets.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
      "featured_image_media": {
        "alt_text": "Rooftop deck with seating and dining areas overlooking trees and cityscape.",
        "public_id": "019fc98c-46fe-75d9-88b0-660d469e7f49",
        "storage_key": "property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Penn Valley Dog Park KC",
      "seo_description": "Live near Penn Valley Off Leash Dog Park at The Dorset. Perfect for pet owners seeking a convenient Midtown - Westport location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167618",
      "source": "generator",
      "page_item_url": "dorset-apartments-near-kansas-city-international-airport",
      "search_query": "apartments near kansas city international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Kansas City International Airport",
      "h2_subtitle": "Experience convenient living at The Dorset, with apartments near Kansas City International Airport, perfect for frequent flyers.",
      "page_copy": "Located in the vibrant Midtown - Westport neighborhood, The Dorset offers superb apartments near Kansas City International Airport. This makes it an excellent choice for professionals and travelers who value a quick commute to and from the airport.\n\nOur community features stylish one-, two-, and three-bedroom units complete with high-end finishes and amenities such as package service and air conditioning. The Dorset not only provides easy access to the airport but also to local highlights, ensuring residents enjoy the full spectrum of what Kansas City has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
      "featured_image_media": {
        "alt_text": "Rooftop deck with seating and dining areas overlooking trees and cityscape.",
        "public_id": "019fc98c-46fe-75d9-88b0-660d469e7f49",
        "storage_key": "property/6767906449167618/019fc98c-46fe-75d9-88b0-660d469e7f49.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas City International Airport",
      "seo_description": "Discover The Dorset's convenient location near Kansas City International Airport. Experience a blend of travel convenience and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701893643"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PMQ5329N"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Rise"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/55c517d1-1304-4da4-aec8-055cd591caf7/app.js?nocache=1&gaTracking=G-DMKCDENH1R&buttonbgcolor=6469af&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "816-670-3487"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InZIc2RmRCtxVXZKMXJjNUhySmNMREE9PSIsInZhbHVlIjoiVUFCOWZDY3ZIWkl6S0cxZ1BxTEs5dz09IiwibWFjIjoiYjRmZjFhODM1ODBlMDQ2MzE4ZTZlMDk0OWY4YjlkYjIzYmI4Y2FhYjdlOWY0ZjI3YmJmODUwNmJiNWJlZTRmMCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701893643",
  "custom_google_gtm_id": "GTM-PMQ5329N",
  "custom_rollout_phase": "Batch 3",
  "custom_vibesites_theme": "Rise",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/55c517d1-1304-4da4-aec8-055cd591caf7/app.js?nocache=1&gaTracking=G-DMKCDENH1R&buttonbgcolor=6469af&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "816-670-3487",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InZIc2RmRCtxVXZKMXJjNUhySmNMREE9PSIsInZhbHVlIjoiVUFCOWZDY3ZIWkl6S0cxZ1BxTEs5dz09IiwibWFjIjoiYjRmZjFhODM1ODBlMDQ2MzE4ZTZlMDk0OWY4YjlkYjIzYmI4Y2FhYjdlOWY0ZjI3YmJmODUwNmJiNWJlZTRmMCJ9",
  "custom_audioeye_site_id": "50f22e2b-a709-42c4-a931-7b9eeb084586",
  "custom_audioeye_site_hash": "717800e01a5c26bfbaf7a2ceecf8f542"
};

export const generatedAt = '2026-11-03T22:58:15.859Z';
